<template>
  <div class="md-layout case-view-wrapper" v-if="$route.params.id">

    <div class="_portalRoot">

      <!-- <portal to="sidepanel-portal-toggle-bar-info">
        <SidebarToggleBarInfo :items="sidePanelToggleBarInfoItems" />
      </portal> -->
      
      <portal to="sidepanel-portal-details">
        <CaseTask :isIframeMode="true" :iframeModelId="iframeModelId" v-if="iframeModelId" />
      </portal>

      <portal to="sidepanel-portal-attachments">
        <Attachments
          :isDeleteDisabled="true"
          v-if="recordData && recordData.id"
          :relations="attachmentRelations"
          ref="attachmentsListRefs"
          :filter="{
            bool: {
              must: [
                { match_phrase: { relationCaseId: recordData.id } },
                { match_phrase: { fromModelType: 'Case' } },
                { match_phrase: { toModelType: 'Attachment' } },
              ]
            }
          }"
        />
      </portal>

      <portal to="sidepanel-portal-feed">

        <md-tabs :md-active-tab="activeEditorTab" @md-changed="tabChanged">
          <md-tab id="tab-reply" md-label="Reply" :class="{ _isActive: 'tab-reply' == activeEditorTab }" :md-disabled="!(recordData && recordData.person)">
            <div  v-show="showEditorFlag">
              <div  :class="[{ _isReplyTab: 'tab-reply' == activeEditorTab },
              $Session && $Session.isInternalGroupMember ? '_embeddedControlsAdmin' : '_embeddedControls']">
                <md-field class="_embeddedLabel" :class="[
                          { 'md-error': $v.reply.to.CustomEmailValidator },
                          { 'md-error': !$v.reply.to.required },
                          { 'md-valid': !$v.reply.to.CustomEmailValidator },
                          'md-size-5 md-form-label'
                        ]">
                  <md-icon>To:</md-icon>
                  <md-input type="text" name="to" v-model="reply.to"></md-input>
                </md-field>
                <md-field class="_embeddedLabel" :class="[
                          { 'md-error': $v.reply.cc.CustomEmailValidator },
                          { 'md-valid': !$v.reply.cc.CustomEmailValidator },
                          'md-size-5 md-form-label'
                        ]">
                  <md-icon>Cc:</md-icon>
                  <md-input type="text" name="cc" v-model="reply.cc"></md-input>
                </md-field>
                <md-field class="_embeddedLabel" :class="[
                          { 'md-error': $v.reply.bcc.CustomEmailValidator },
                          { 'md-valid': !$v.reply.bcc.CustomEmailValidator },
                          'md-size-5 md-form-label'
                        ]">
                  <md-icon>Bcc:</md-icon>
                  <md-input type="text" name="bcc" v-model="reply.bcc"></md-input>
                </md-field>
                <md-field class="_embeddedLabel">
                  <md-icon>Sub:</md-icon>
                  <md-input type="text" name="bcc" v-model="reply.subject" disabled></md-input>
                </md-field>
              </div>
              <md-checkbox v-show="$Session && $Session.isInternalGroupMember" class="_isInternalCheckbox" v-model="reply.internal">Internal</md-checkbox>
              <md-button class="md-sm md-success _submitTinyMceBtn" :disabled="!isReplyEditorValid" @click="sendMail('reply')">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i>
              </md-button>
              <TinyMceEditor v-model="reply.body" theId="reply" v-on:input="debounceReplyInput" contentStyle="body { padding-top: 140px; }"/>
              <md-card-actions md-alignment="left" v-if="!files.length">
                <input type="file" multiple id="multiplFiles" ref="multiplFiles" v-on:change="handleFileUpload()"/>
                <md-button class="md-simple md-just-icon _attachFileBtn">
                  <i class="material-icons" v-on:click="addFiles()">attachment</i>
                </md-button>
                <span>Browse or attach file here</span>
              </md-card-actions>
              <md-card-content v-if="files.length" class="attachment-area">
                <div class="md-layout">
                  <md-card-actions md-alignment="left">
                    <input type="file" multiple id="multiplFiles" ref="multiplFiles" v-on:change="handleFileUpload()"/>
                    <md-button class="md-simple md-just-icon _attachFileBtn">
                      <i class="material-icons" v-on:click="addFiles()">attachment</i>
                    </md-button>
                  </md-card-actions>
                  <div class="md-layout-item">
                    <div class="md-layout md-gutter md-alignment-center" v-for="(files, chunkIndex) in chunkFiles" v-bind:key="chunkIndex">
                      <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(file, fileIndex) in files" v-bind:key="fileIndex" >
                        <div v-show="file.name" class="attchment-card">
                          <div class="attchment-container">{{ file.name }} ({{ file.size | kb }} kb)
                            <button type="button" class="attachment-button" title="Remove" @click="removeFile(file)" >x</button>
                          </div>
                          <md-checkbox 
                            class="attachment-area__checkbox" 
                            v-show="$Session && $Session.isInternalGroupMember"
                            v-model="attachmentOptions[getAttachmentIndex(chunkIndex, fileIndex)].internal"
                          >Internal</md-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
              <md-card-actions md-alignment="right">
                <md-button class="md-sm md-danger"  @click="closeEditor('reply')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
              </md-card-actions>
            </div>
            <div v-show="!showEditorFlag" @click="showEditor('reply')">
              Write your reply here.
            </div>
          </md-tab>
          <md-tab id="tab-note" md-label="Note" :class="{ _isActive: 'tab-note' == activeEditorTab }">
            <div v-show="showEditorFlag">
              <md-checkbox v-show="$Session && $Session.isInternalGroupMember" class="_isInternalCheckbox" v-model="isNoteInternal">Internal</md-checkbox>
              <md-button class="md-sm md-success _submitTinyMceBtn" :disabled="note.body==''" @click="sendNote()">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i>
              </md-button>
              <TinyMceEditor v-model="note.body" theId="note" :isNote="true" :mentionArr="userListItems" @itemSelected="noteItemSelected" /> 
              <div class="md-space-between">
                <md-card-actions md-alignment="left">
                  <md-button class="md-simple md-just-icon _attachFileBtn">
                    <i class="material-icons" v-on:click="onOpenAttachmentDialog()">attachment</i>
                  </md-button>
                  <span v-if="attachmentData == null">Browse or attach file here</span>
                </md-card-actions>
                <md-card-actions md-alignment="right">                
                  <md-button class="md-sm md-danger"  @click="closeEditor('note')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
                </md-card-actions>
              </div>
            </div>
            <div v-show="!showEditorFlag" @click="showEditor('note')">
              Write your note here.
            </div>
          </md-tab>
          <md-tab id="tab-forward" md-label="Forward" class="_relative" :class="{ _isActive: 'tab-forward' == activeEditorTab }" :md-disabled="!(recordData && recordData.person)">
            <div  v-show="showEditorFlag">
              <div :class="[{ _isForwardTab: 'tab-forward' == activeEditorTab },
               $Session && $Session.isInternalGroupMember ? '_embeddedControlsAdmin' : '_embeddedControls']">
                <md-field class="_embeddedLabel" :class="[
                          { 'md-error': $v.forward.to.CustomEmailValidator },
                          { 'md-error': !$v.forward.to.required },
                          { 'md-valid': !$v.forward.to.CustomEmailValidator },
                          'md-size-5 md-form-label'
                        ]">
                  <md-icon>To:</md-icon>
                  <md-input type="text" name="to" v-model="forward.to"></md-input>
                </md-field>
                <md-field class="_embeddedLabel" :class="[
                          { 'md-error': $v.forward.cc.CustomEmailValidator },
                          { 'md-valid': !$v.forward.cc.CustomEmailValidator },
                          'md-size-5 md-form-label'
                        ]">
                  <md-icon>Cc:</md-icon>
                  <md-input type="text" name="cc" v-model="forward.cc"></md-input>
                </md-field>
                <md-field class="_embeddedLabel" :class="[
                          { 'md-error': $v.forward.bcc.CustomEmailValidator },
                          { 'md-valid': !$v.forward.bcc.CustomEmailValidator },
                          'md-size-5 md-form-label'
                        ]">
                  <md-icon>Bcc:</md-icon>
                  <md-input type="text" name="bcc" v-model="forward.bcc"></md-input>
                </md-field>
                <md-field class="_embeddedLabel">
                  <md-icon>Sub:</md-icon>
                  <md-input type="text" name="bcc" v-model="forward.subject" disabled></md-input>
                </md-field>
              </div>
              <md-checkbox v-show="$Session && $Session.isInternalGroupMember" class="_isInternalCheckbox" v-model="forward.internal">Internal</md-checkbox>
              <md-button class="md-sm md-success _submitTinyMceBtn" :disabled="!isForwardEditorValid" @click="sendMail('forward')">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i>
              </md-button>
              <TinyMceEditor v-model="forward.body" theId="forward" v-on:input="debounceForwardInput" contentStyle="body { padding-top: 140px; }"/>
              <md-card-actions md-alignment="left" v-if="!files.length">
                <input type="file" multiple id="multiplFiles" ref="multiplFiles" v-on:change="handleFileUpload()"/>
                <md-button class="md-simple md-just-icon _attachFileBtn">
                  <i class="material-icons" v-on:click="addFiles()">attachment</i>
                </md-button>
                <span>Browse or attach file here</span>
              </md-card-actions>
              <md-card-content v-if="files.length" class="attachment-area">
                <div class="md-layout">
                  <md-card-actions md-alignment="left">
                    <input type="file" multiple id="multiplFiles" ref="multiplFiles" v-on:change="handleFileUpload()"/>
                    <md-button class="md-simple md-just-icon _attachFileBtn">
                      <i class="material-icons" v-on:click="addFiles()">attachment</i>
                    </md-button>
                  </md-card-actions>
                  <div class="md-layout-item">
                    <div class="md-layout md-gutter md-alignment-center" v-for="(files, chunkIndex) in chunkFiles" v-bind:key="chunkIndex">
                      <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(file, fileIndex) in files" v-bind:key="fileIndex" >
                        <div v-show="file.name" class="attchment-card">
                          <div class="attchment-container">{{ file.name }} ({{ file.size | kb }} kb)
                            <button type="button" class="attachment-button" title="Remove" @click="removeFile(file)" >x</button>
                          </div>
                          <md-checkbox 
                            class="attachment-area__checkbox" 
                            v-show="$Session && $Session.isInternalGroupMember"
                            v-model="attachmentOptions[getAttachmentIndex(chunkIndex, fileIndex)].internal"
                          >Internal</md-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
              <md-card-actions md-alignment="right">
                <md-button class="md-sm md-danger"  @click="closeEditor('forward')"><i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel</md-button>
              </md-card-actions>
            </div>
            <div v-show="!showEditorFlag" @click="showEditor('forward')">
              Write your forward here.
            </div>
          </md-tab>
        </md-tabs>      

        <!-- Upload Dialog -->
        <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
          <md-dialog-title>Attachment</md-dialog-title>
          <md-dialog-content>
            <CommentAttachmentsForm
              :docTypes="docTypes"
              :model="attachmentData"
              @success="onUploadSuccess"
            />
          </md-dialog-content>
        </md-dialog>
        <!--  -->
        <FilterMessageList @filter="onMessagesAndNotesFilterChange" :items="messagesAndNotes" />
        <CaseFeed 
          :items="messagesAndNotesActive" 
          :caseId="$route.params.id" 
          :userListItems="userListItems" 
          :atReply="onReply" 
          :atNoteEdit="onNoteEdit"
          :atShowAttachment="onShowAttachment"
          :manualCase="manualCase"
          :newAddedComment="newAddedComment"
        />
        <md-button 
          class="md-sm md-primary" 
          @click="loadNextMessagesAndNotes" 
          title="Load More" 
          v-if="messagesAndNotesHasMore"
        >Load More</md-button>
      </portal>

      <!-- Sidebar: Linked Cases Tab -->	
      <portal to="sidepanel-portal-links">	
        <ElasticList 
          :list.sync="linkedCasesList" 
          :filter="linkedCaseFilter" 
          ref="linkedCasesListRef" 
          class=caseLinkTab
        ></ElasticList>
        <md-dialog :md-active.sync="linkedCasesList.showRelatedDialog">	
          <md-dialog-title>{{relateCasesList.pageTitle}}</md-dialog-title>	
          	
          <md-dialog-content>	
            <ElasticList	
              v-if="recordData"	
              :list.sync="relateCasesList"	
              :exclude="relateCasesListFilter"
              :relateRecordInput="{caseId: $route.params.id}"	
            ></ElasticList>	
          </md-dialog-content>

          <md-dialog-actions>	
            <md-button class="md-theme-default" @click="linkedCasesList.showRelatedDialog = false; linkedCasesList.needsRefresh = true;">Close</md-button>	
          </md-dialog-actions>	
        </md-dialog>	
      </portal>

      <!--  -->
      <!-- <template v-slot:details> -->
        <!--  -->
      <!-- </template> -->

    <!-- </Sidebar> -->
    </div>

    <md-dialog-alert
        :md-active.sync="dialog.status"
        :md-content="dialog.content"
        :md-confirm-text="dialog.confirmText"
        @md-closed="dialog.content = ''"/>
    <div  id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div v-if="recordData && recordData.services && recordData.services.items && recordData.services.items[0] && recordData.services.items[0].service">
        <h1 class="md-title compact content-wrap">
          <a :href="'#/services/' + recordData.services.items[0].service.id" class="icon-color">
            {{ recordData.services.items[0].service.name }}</a>
        </h1>
        <h2 v-if="recordData.services.items[0].service && recordData.services.items[0].service.merchantNumber" class="compact">MID: {{ recordData.services.items[0].service.merchantNumber }}</h2>
        <h3 class="sub-header content-wrap"> Case: {{recordData? recordData.subject : ''}}</h3>
      </div>
      <div v-else>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.subject : ''}}</h1>
      </div>
    </div>
    <div class="md-toolbar-row case-avatar-row"  v-if="recordData && recordData.person">
      <div style=""><md-avatar><img src="img/default-avatar.png" alt="Avatar"></md-avatar></div>
      <div>
        <h2 class="md-title">{{ recordData ? (recordData.person && recordData.person.given_name && recordData.person.family_name) ? (recordData.person.given_name + ' ' + recordData.person.family_name) : '' : '' }}</h2>   
      </div>
    </div>
    <div class="md-toolbar-row created-date-row">
      <div class="created-date">Created {{ recordData? new Date(recordData.createdAt) : '' | moment("MMM Do YYYY - HH:mm") }}</div>           
    </div>

    <!-- Edit Case Form -->
    <CustomCaseConfigForm 
      :isCompleteInOrder="form.isCompleteInOrder" 
      :templateTasks="templateTasks" 
      :existingTasks="existingTasks" 
      :reassignTasks="caseAssignee" 
      :atShowAuditLog="onShowAuditLog" 
      :update="updateForm" 
      :form="form" 
      :$v="$v" 
      :formConfig="formConfig" 
      :recordData="recordData" 
      :headerColor="headerColor" 
      :setCloseDate="setCloseDate"
    ></CustomCaseConfigForm>

    <md-dialog :md-active.sync="auditLogDialog">
      <md-dialog-title>Audit Log</md-dialog-title>
      <md-dialog-content>
        <AuditLogDialog :list.sync="auditLogList" :filter.sync="auditLogFilter"
        ></AuditLogDialog>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-theme-default" @click="auditLogDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <div class="dynamicList-loading-spinner" v-show="promisePending">
      <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>


    <md-snackbar
      :md-position="'center'"
      :md-duration="4000"
      :md-active.sync="snackbar.status"
      md-persistent
    >
      <span class="md-sm md-primary">
        {{snackbar.content}} &nbsp;
        <i class="md-icon md-icon-font md-bottom-bar-icon md-accent">{{snackbar.icon}}</i>
      </span>      
    </md-snackbar>

    <!-- <div class="mdTabs" v-show="formConfig.pageMode === 'view'">
    <div v-if="$route.params.id">  
    </div>
    </div> -->
    <!-- <div class="mdTabs" v-if="$route.params.id">
      <md-tabs :md-active-tab="activeFeedAndTasksTabId" @md-changed="onFeedAndTasksTabChanged">
        <md-tab id="tab-message" md-label="Feed" :class="{ _isActive: 'tab-message' == activeFeedAndTasksTabId }">
          <FilterMessageList @filter="onMessagesAndNotesFilterChange" :items="messagesAndNotes" />
          <CaseFeed 
            :items="messagesAndNotesActive" 
            :caseId="$route.params.id" 
            :userListItems="userListItems" 
            :atReply="onReply" 
            :atNoteEdit="onNoteEdit"
            :atShowAttachment="onShowAttachment"
          />
          <md-button 
            class="md-sm md-primary" 
            @click="loadNextMessagesAndNotes" 
            title="Load More" 
            v-if="messagesAndNotesHasMore"
          >Load More</md-button>
        </md-tab>

        <md-tab id="tab-tasks" md-label="Tasks" :class="{ _isActive: 'tab-tasks' == activeFeedAndTasksTabId }">
          <CustomTaskList 
            v-if="$route && tasksList.tableData" 
            :list.sync="tasksList" 
            :filter="taskCaseIdFilter"
            @groupChange="onGroupChange"
            @orderChange="onOrderChange"
          ></CustomTaskList>

          <md-dialog :md-active.sync="tasksList.showRelatedDialog">
            <md-dialog-title>{{relateTasksList.pageTitle}}</md-dialog-title>
            <md-dialog-content>

              <CustomTaskDialog
                v-if="recordData"
                :list.sync="relateTasksList"
                :exclude="relateTasksListFilter"
                :relateRecordInput="{taskCaseId: $route.params.id, group: groupIndex, order: orderIndex}"
                relateRecordInputField="id"
                @dialogChange="onDialogChange"
              ></CustomTaskDialog>

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="tasksList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>
      </md-tabs>
    </div> -->

    <div class="md-layout-item md-size-100 _taskLayoutCard" v-if="formConfig.pageMode === 'view' || formConfig.pageMode === 'assignee'">
          <collapse class="collapse-head"
            :collapse="[
              'Tasks',
            ]"
            icon="keyboard_arrow_down"
            color-collapse="success _collapseFeed _collapseCaseFeed"
            :defaultActive="defaultActiveCollapseIndex"
            id="Tasks"
          >
            <template slot="md-collapse-pane-1">
              <!-- <CustomTaskList 
                v-if="$route && tasksList.tableData && isAuthLoaded" 
                :list.sync="tasksList" 
                :filter="taskCaseIdFilter"
                :isCompleteInOrder="form.isCompleteInOrder" 
                @groupChange="onGroupChange"
                @orderChange="onOrderChange"
              ></CustomTaskList> -->
              
              <CaseTaskViewComponent 
                :caseId="recordData.id"
              />

              <div slot="footer" class="row list-group-item item" role="group" v-if="!recordData.isCompleteInOrder">
                <div class="md-layout md-alignment-center-right _footerSlot">
                  <md-button 
                    class="md-button md-primary md-sm _smBtn" 
                    v-on:click="addTask()" 
                  >Add Task<md-icon class="md-small">control_point</md-icon></md-button>
                </div>
              </div>

              <md-dialog :md-active.sync="tasksList.showRelatedDialog">
                <md-dialog-title>{{relateTasksList.pageTitle}}</md-dialog-title>
                <md-dialog-content>

                  <CustomTaskDialog
                    v-if="recordData && isAuthLoaded"
                    :list.sync="relateTasksList"
                    :filter="taskTemplateFilter"
                    :exclude="relateTasksListFilter"
                    :relateRecordInput="{taskCaseId: $route.params.id, group: groupIndex, order: orderIndex}"
                    relateRecordInputField="id"
                    @dialogChange="onDialogChange"
                  ></CustomTaskDialog>

                </md-dialog-content>
                <md-dialog-actions>
                  <md-button class="md-theme-default" @click="tasksList.showRelatedDialog = false">Close</md-button>
                </md-dialog-actions>
              </md-dialog>
              
              <md-dialog :md-active.sync="tasksList.showRelatedDialog">
                <md-dialog-title>{{relateTasksList.pageTitle}}</md-dialog-title>
                <md-dialog-content>

                  <CustomCaseTaskDialog
                    v-if="recordData && isAuthLoaded"
                    :list.sync="relateCaseTasksList"
                    :filter="taskTemplateFilter"
                    :exclude="relateTasksListFilter"
                    :relateRecordInput="{taskCaseId: $route.params.id, group: groupIndex, order: orderIndex}"
                    relateRecordInputField="id"
                    @dialogChange="onDialogChange"
                    @addTaskToCaseTemplate="onAddTaskToCaseTemplate"
                    @taskCreated="onTaskCreated"
                  ></CustomCaseTaskDialog>

                </md-dialog-content>
                <md-dialog-actions>
                  <md-button class="md-theme-default" @click="tasksList.showRelatedDialog = false">Close</md-button>
                </md-dialog-actions>
              </md-dialog>
              
            </template>
          </collapse>
          <br>
          <!-- <collapse class="collapse-head"
            :collapse="[
              'Feed',
            ]"
            icon="keyboard_arrow_down"
            color-collapse="success _collapseFeed"
            :defaultActive="defaultActiveCollapseIndex"
            id="Feed"
          >
            <template slot="md-collapse-pane-1">
              <FilterMessageList @filter="onMessagesAndNotesFilterChange" :items="messagesAndNotes" />
              <CaseFeed 
                :items="messagesAndNotesActive" 
                :caseId="$route.params.id" 
                :userListItems="userListItems" 
                :atReply="onReply" 
                :atNoteEdit="onNoteEdit"
                :atShowAttachment="onShowAttachment"
                :manualCase="manualCase"
              />
              <md-button 
                class="md-sm md-primary" 
                @click="loadNextMessagesAndNotes" 
                title="Load More" 
                v-if="messagesAndNotesHasMore"
              >Load More</md-button>
            </template>
            
          </collapse> -->
    </div>

    <!-- Merge Case Dialog -->
    <md-dialog :md-active.sync="mergeCaseList.showRelatedDialog">
      <md-dialog-title>{{mergeCaseList.pageTitle}}</md-dialog-title>
      <md-dialog-content>
        <CaseMergeComponent
          v-if="$route && mergeCaseList.tableData"
          :list.sync="mergeCaseList"
        ></CaseMergeComponent>
      </md-dialog-content>
    </md-dialog>

    <!-- ATLAS-961: Reassigning Case to a new Assignee Popup -->
    <md-dialog :md-active.sync="caseAssignee.showRelatedDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="__custom-dialog-title">{{caseAssignee.pageTitle}}
        <span @click="caseAssignee.showRelatedDialog = false">
          <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default __closeDialogIcon">close</i>
        </span>
      </md-dialog-title>

      <md-dialog-content class="__custom-dialog-content">
        <ReassignTaskList
        :list.sync="caseAssignee">
        </ReassignTaskList>
      </md-dialog-content>
    </md-dialog>

  </div>
  <div v-else class="md-layout-item md-small-size-100">
    <!-- Create Case Form -->
    <CustomCaseConfigForm 
      :templateTasks="templateTasks"
      :existingTasks="existingTasks"
      :reassignTasks="caseAssignee"
      :atShowAuditLog="onShowAuditLog"
      :update="updateForm"
      :form="form"
      :$v="$v"
      :formConfig="formConfig"
      :headerColor="headerColor"
      :setCloseDate="setCloseDate"
    ></CustomCaseConfigForm>
  </div>
</template>

<script>
  import Record from '@/mixins/Record';

  import CustomTaskList from "@/components/DynamicForm/CustomTaskList";
  import CustomTaskDialog from "@/components/DynamicForm/CustomTaskDialog";
  import CustomCaseTaskDialog from "@/components/DynamicForm/CustomCaseTaskDialog";
  import FilterMessageList from '@/components/DynamicForm/FilterMessageList';
  import AuditLogDialog from "@/components/DynamicForm/AuditLogDialog";
  import CaseMergeComponent from '@/components/DynamicForm/CaseMergeComponent';
  import ReassignTaskList from '@/components/DynamicForm/ReassignTaskList'
  
  import CaseTaskViewComponent from '@/components/DynamicForm/CaseTaskView/CaseTaskViewComponent';
  import CaseTask from '@/components/DynamicForm/CaseTask';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";

  import {Auth, API, graphqlOperation, Storage } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as mutations from '@/graphql/mutations';
  
  import TinyMceEditor from '@/components/Editor/TinyMceEditor';
  import CaseFeed from '@/components/CaseFeed';
  import SidebarToggleBarInfo from '@/components/Sidebar/SidebarToggleBarInfo';
  import Attachments from '@/components/DynamicForm/Attachments/Attachments';
  import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
  // custom email validation for to. cc and bcc
  import { CustomEmailValidator } from '@/plugins/vuelidate/custom-email-validator';

  const uuidv1 = require('uuid/v1');
  import aws_exports from "../../aws-exports";

  import moment from 'moment';
  import _ from 'lodash';
    
  import AttachmentsForm from '@/components/DynamicForm/Attachments/AttachmentsForm';
  const AttachmentsFormMixin = {
    methods: {
      add: AttachmentsForm.methods.add,
      updateAttachment : AttachmentsForm.methods.updateAttachment,
      createAttachment: AttachmentsForm.methods.createAttachment,
      deleteAttachments: AttachmentsForm.methods.deleteAttachments,
      createRelations: AttachmentsForm.methods.createRelations,
      getAwsCredentials: AttachmentsForm.methods.getAwsCredentials,
      onComplete: AttachmentsForm.methods.onComplete,
      showNotification: AttachmentsForm.methods.showNotification,
      uploadFile: AttachmentsForm.methods.uploadFile,
      uploadToAwsS3: AttachmentsForm.methods.uploadToAwsS3,
    }
  };
  
  import { Collapse } from "@/components";
  import * as queries_custom from "@/graphql/queries_custom";
  const AttachmentsMixin = {
    methods: {
      getDocTypes: Attachments.methods.getDocTypes,
    }
  };

  export default {
    name: "case",
    mixins: [Record, AttachmentsMixin, AttachmentsFormMixin],
    components: {
      TinyMceEditor,
      CustomTaskList,
      CustomTaskDialog,
      CustomCaseTaskDialog,
      CaseFeed,
      FilterMessageList,
      AuditLogDialog,
      CaseMergeComponent,
      Collapse,
      CaseTaskViewComponent,
      ReassignTaskList,
      SidebarToggleBarInfo,
      Attachments,
      CaseTask,
      CommentAttachmentsForm,
    },
    computed: {
      attachmentRelations() {
        const relations = [];

        const recordData = this.recordData;
        if (!recordData || !recordData.id) {
          return relations;
        }

        // case relation
        relations.push({ fromModelType: 'Case', relationCaseId: recordData.id });

        // attached service relations
        const services = this.$reduce(recordData, 'services.items');
        if (services && services.length) {
          for (const _serviceRelation of services) {
            const serviceId = this.$reduce(_serviceRelation, 'service.id');
            if (serviceId) {
              relations.push({ fromModelType: 'Service', relationServiceId: serviceId });
            }
          }
        }

        return relations;
      },
      sidePanelToggleBarInfoItems() {
        const items = [];
        if (!this.recordData || !this.recordData.id) {
          return items;
        }
        
        // push subject
        const subject = this.$reduce(this, 'recordData.subject');
        if (subject) {
          items.push({ text: subject, icon: 'file_copy' });
        }

        return items;
      },
      auditLogFilter() {
        return [
          { match_phrase: { modelName: 'Case' } },
          { match_phrase: { modelId: this.$route.params.id } },
        ];
      },
      messageCaseIdFilter: function () { return {"match": {"messageCaseId.keyword": this.$route.params.id }}; },
      taskCaseIdFilter: function () { 
        const filter = {
          taskCaseId: { eq: this.$route.params.id }
        }; 
        if (!this.$Session.isInternalGroupMember) {
          filter.internal = { eq: false };
        }
        return filter;
      },
      taskTemplateFilter: function () {
        return { bool: { must: { match: { isTemplate: true } } } };
      },
      relateTasksListFilter: function () {
        let result = null;
        if (this.recordData) {
          let filters = [];
          filters.push({"match": {"taskCaseId": this.recordData.id}});

          if (filters.length) {
            result = {"must_not": filters};
          }
        }
        return result;
      },
      messagesAndNotesActive() {
        const length = this.messagesAndNotesPage * this.messagesAndNotesItemsPerPage;
        return this.messagesAndNotesFiltered.slice(0, length);
      },
      messagesAndNotesHasMore() {
        return this.messagesAndNotesFiltered.length > this.messagesAndNotesActive.length;
      },
      isReplyEditorValid() { 
        return (
          this.reply.body && 
          this.reply.body.trim().length && 
          this.reply.to &&
          this.reply.to.trim().length &&
          !this.$v.reply.to.CustomEmailValidator && 
          (!this.$v.reply.cc || !this.$v.reply.cc.CustomEmailValidator) && 
          (!this.$v.reply.bcc || !this.$v.reply.bcc.CustomEmailValidator)
        ); 
      },
      isForwardEditorValid() {
        return (
          this.forward.body &&
          this.forward.body.trim().length &&
          this.forward.to &&
          this.forward.to.trim().length &&
          !this.$v.forward.to.CustomEmailValidator &&
          !this.$v.forward.cc.CustomEmailValidator && 
          !this.$v.forward.bcc.CustomEmailValidator
        );
      },
      isAuthLoaded() {
        return this.$reduce(this, '$Session.user');
      },
      relateCasesListFilter: function () {
        let result = null;
        let filters = [{"match": {"id": this.$route.params.id}}];
        if (this.updateFormData && this.updateFormData.searchCaseLinks && this.updateFormData.searchCaseLinks.items && this.updateFormData.searchCaseLinks.items.length) {
          this.updateFormData.searchCaseLinks.items.forEach((item) => {
            filters.push({"match": {"id": item.linkCase.id}});
          })
        }
        if (filters.length) {
          result = {"must_not": filters};
        }
        return result;
      },
      linkedCaseFilter: function() {
        const id = this.$route.params.id ? this.$route.params.id: -1;
        const mustIds = [];
        //Match ID
        mustIds.push(
          { match_phrase: { caseLinkCaseId: id } },
          { match_phrase: { caseLinkLinkCaseId: id } }
        );

        const filter = { bool: { should: mustIds } };
        return filter;
      },
    },
    data() {
      return {
        shouldShowAlertMessage: true,
        noticationTimeStamp: [],
        attachments: [],
        iframeModelId: null,
        auditLogDialog: false,
        workflowCaseTempList: [],
        reservedNameValidatorTimeoutId: null,
        isFirstTimeReservedNameCheck: true,
        caseAssignee: {
          showRelatedDialog: false,
          pageTitle: '',
          reassignTasks: [],
          selectedTasks: [],
          skipReassignTasks: false,
          closeDialogClicked: false
        },
        auditLogList: {
          hideItemActions: true,
          skipCardLayout: true,
          hideListHeader: true,
          hideNewRecordButton: true,
          searchRecordsInput: false,
          pageTitle: "Change History",
          listQueryId: "searchChanges",
          columns: {
            createdAt: { label: "Created", sortable: true },
            user: { label: "Owner", sortable: false },
            change: { label: "Change", sortable: false },                 
          },
          currentSort: "createdAt",
          currentSortOrder: "asc",
          pagination: {
            perPage: 10,
            currentPage: 1,
            total: 0,
            perPageOptions: [5, 10, 20, 25, 50],
            perPageMaxLimit: 999
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          assigneeList: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchChanges && data.searchChanges.items.length) {
              let items = data.searchChanges.items;
              items.forEach((item) => {
                /** Format user and change for display */
                item.user = item.user ? item.user.given_name + ' ' + item.user.family_name : item.owner;
                item.createdAt = moment(String(item.createdAt)).format('MMM DD, YYYY h:mm:ss a')                
                if (item.change)  {
                  let change = '';
                  _.mapKeys(JSON.parse(item.change), function(value, key) {
                    if(/(Mon|Tue|Wed|Thu|Fri|Sat|Sun)\,\s+(\d{2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{4})\s+(\d{2}\:\d{2}\:\d{2})\s+(GMT)/ig.test(value)) {
                      change = change + key + ' : ' + moment(value).format("MMM DD, YYYY") + ', ';
                    } else 
                      change = change + key + ' : ' + value + ', ';
                  });
                  item.change = change;
                } 
                result.push(item);
              })
            }
            return this.orderedAuditLog(result)
          },
        },
        deleteQueue: {},
        updateFormData: {},
        templateTasks: {},
        existingTasks: {},
        manualCase: false,
        newComment: [],
        newAddedComment: [],
        setCloseDate: true,
        attachmentFetchedMessagesId: [],
        searchError: true,
        searchErrorMessage: '',
        showEditorFlag: false,
        files:[],
        chunkFiles:[],
        userListItems: [],
        changeListItems: {},
        noteMentionList: [],
        dialog: {
          'status': false,
          'content': "",
          'confirmText': "Ok!"
        },
        snackbar: {
          'status': false,
          'content': "",
          'icon': "done"
        },
        reply: {
          internal: false,
          to: '',
          cc: '',
          bcc: '',
        },
        forward: {
          internal: false,
          to: '',
          cc: '',
          bcc: '',
        },
        note: {
          body: '',
          internal: false,
        },
        blockChangeTab: null,
        replyItem: null,
        attachmentOptions: [],
        noteItem: null,
        isNoteInternal: false,
        defaultItem: {},
        promisePending: false,
        saveDraft : true,
        updateDraft : false,
        draftPromisePending : false,
        draftDeletePromisePending : false,
        draftSavedStatus : false,
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'caseUpdatedById',
          updatedByTaskFieldName: 'taskUpdatedById',
          updatedByTaskStepFieldName: 'taskStepUpdatedById',
          responseFieldName: 'getCase',
          removeFields: ['accounts', 'companies', 'services', 'products', 'salesreps'],
          actions: {
            save: 'createCase',
            view: 'editCase',
            edit: 'editCase',
            new: 'newCase',
            update: 'updateCase',
            delete: 'deleteCase',
          },
          listPath: "/cases",
          headerIcon: 'how_to_vote',
          objectNamePlural: 'Cases',
          editMode: false,
          limit: {
            messagesLimit: 999,
            notesLimit: 999,
            usersLimit: 999,
            caseTemplatesLimit: 99,
            personLimit: 999,
            changeLimit: 999,
          },
          showMergeCaseOption: false,
          openCaseMergeDialog: this.openCaseMergeDialog,
          redirectTemp: false,
          messagesFilter: undefined,
          caseLinksFilter:  'caseLinkCaseId',
          objectName: 'Case',
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          slots: {
            basic: {label: 'Case Details', icon: 'how_to_vote', layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}, id: "CaseDetails"},
            targets: {label: 'Case Targets', icon: 'my_location', editModeOnly: true, layout: {"x":0,"y":0,"w":12,"h":0,"i":"1"}, id: "CaseTargets", inSidePanel:"true"},
          },
          fields: {
            caseTemplateId: { 
              label: 'Template',  
              type: 'select', 
              slot: 'basic', 
              options: [],
              preventEdit: false,
              hide: () => {
                const options = this.$reduce(this, 'formConfig.fields.caseTemplateId.options');
                return !options || 0 == options.length;
              }
            },
            id: {label: "ID", type: "id", slot: 'basic'},
            subject: {label: "Subject", type: "text", slot: 'basic', uniqueErrorMessage: 'Can not use this name as it is reserved.'},
            internal: {
              label: "Internal",
              type: "switch",
              slot: 'basic',
              hide: (this.$Session && this.$Session.isInternalGroupMember) ? false : true,
              preventEdit: !this.$Session.isInternalGroupMember
            },
            priority: {label: "Priority", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            alertMessage: { label: "Alert Message", type: "text", slot: 'basic' },
            rushReason: {
              label: "RushReason",
              type: "text",
              slot: 'basic',
              hide: () => {
                return (this.form && this.form.priority !== 'Rush');
              }
            },
            origin: {label: "Origin", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            type: {label: "Type", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            status: {label: "Status", type: "select", slot: 'basic', options: [], optionType: 'enum',
                hide: () => {
                return !(this.formConfig.pageMode === 'new')
              },
            },
            quickNote: {label: "Quick Note", type: "textarea", slot: 'basic'},
            // services: {label: "Services", type: "text", slot: 'targets'},
            // products: {label: "Products", type: "text", slot: 'targets'},
            caseUserId: { label: "Assignee", type: "autocomplete", slot: 'basic',
              hide: () => {
                return !(this.formConfig.pageMode === 'new')
              },
              data: [],
              displayFieldOne: 'given_name', 
              displayFieldTwo: 'family_name',
              searchTerm: "",
              options: [],
              linkBase: '#/users/',
              setVal: (val) => {
                this.$v.form.caseUserId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.given_name + ' ' + c.family_name;
              })(this.formConfig.fields.caseUserId)},
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchUsers',
              lazyLoadResponseFieldName: 'searchUsers',
              lazyLoadSearchableFields: ['given_name', 'family_name'],
              // change: (search) => {(($this) => {
              //   const data = $this.data;
              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
              //       if (!search) {
              //         $this.setVal("");
              //         $this.searchTerm = "";
              //         resolve(data)
              //       } else {
              //         const _term = search.toLowerCase();
              //         let termGivenName = _term.split(' ')[0];
              //         let termFamilyName = _term.split(' ')[1];
                      
              //         let resultGivenName = data.filter(({ given_name }) => given_name.toLowerCase() === termGivenName);
              //         let resultFamilyName = data.filter(({ family_name }) => family_name.toLowerCase() === termFamilyName);
              //         if ((!resultGivenName.length) || (!resultFamilyName.length)) {  
              //           $this.setVal("");
              //           $this.searchTerm = "";
              //         }
              //         resolve(data.filter(({ given_name, family_name }) => (given_name + ' ' + family_name).toLowerCase().includes(_term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.caseUserId)}
            },
            caseTeamId: {label: "Team", type: "autocomplete", slot: "basic",
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/teams/',
              setVal: (val) => {
                this.$v.form.caseTeamId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.caseTeamId)},
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchTeams',
              lazyLoadResponseFieldName: 'searchTeams',
              lazyLoadSearchableFields: ['name'],
              // change: (search) => {(($this) => {
              //   const data = $this.data;
              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
              //       if (!search) {
              //         $this.setVal("");
              //         $this.searchTerm = "";
              //         resolve(data)
              //       } else {
              //         const term = search.toLowerCase();
              //         let result = data.filter(({ name }) => name.toLowerCase() === term);
              //         if (result.length) {
              //           $this.select(result[0]);
              //         } else {
              //           $this.setVal("");
              //           $this.searchTerm = "";
              //         }
              //         resolve(data.filter(({ name }) => name.toLowerCase().includes(term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.caseTeamId)}
            },
            casePersonId: { label: "Person", type: "autocomplete", slot: 'basic',
              data: [],
              displayFieldOne: 'given_name', 
              displayFieldTwo: 'family_name',
              searchTerm: "",
              options: [],
              linkBase: '#/people/',
              setVal: (val) => {
                this.$v.form.casePersonId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.given_name + ' ' + c.family_name;
              })(this.formConfig.fields.casePersonId)},
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchPersons',
              lazyLoadResponseFieldName: 'searchPersons',
              lazyLoadSearchableFields: ['given_name', 'family_name'],
              // change: (search) => {(($this) => {
              //   const data = $this.data;
              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
                    
              //       if (!search) {
              //         $this.setVal("");
              //         $this.searchTerm = "";
              //         resolve(data)
              //       } else {
              //         const term = search.toLowerCase();
              //         let termGivenName = term.split(' ')[0];
              //         let termFamilyName = term.split(' ')[1];
                      
              //         let resultGivenName = data.filter(({ given_name }) => given_name.toLowerCase() === termGivenName);
              //         let resultFamilyName = data.filter(({ family_name }) => family_name.toLowerCase() === termFamilyName);
              //         if ((!resultGivenName.length) || (!resultFamilyName.length)) {  
              //           $this.setVal("");
              //           $this.searchTerm = "";
              //         }
              //         resolve(data.filter(({ given_name, family_name }) => (given_name + ' ' + family_name).toLowerCase().includes(term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.casePersonId)}
            },
            isCompleteInOrder: {label: 'Complete In Order', type: 'switch', slot: 'basic', preventEdit: true }, 
            companies: {
              label: "Companies", type: "searchmodal", slot: 'targets',
              subscribe: {
                'onCreate': {
                  'model': 'CaseCompany',
                  'inputField': 'companies',
                  'target': 'company'
                },
                'onDelete': {
                  'model': 'CaseCompany',
                  'inputField': 'companies',
                  'target': 'company'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "companies",
                objectName: "company",
                pageTitle: "Companies",
                pageIcon: "store",
                listQueryId: "caseTargetSearchCompanys",
                responseFieldName: "searchCompanys",
                createMutationId: "createCaseCompany",
                deleteQueryId: "deleteCaseCompany",
                deleteQueryIdField: "relateRecordId",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Case?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  name: { label: "Name", sortable: false },
                  createdAt: { label: "Created", sortable: false},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                fuseSearch: null,
                relateRecordInput: {caseCompanyCompanyId: null, caseCompanyCaseId: null},
                relateRecordInputField: "caseCompanyCompanyId",
                relateRecordRouteField: "caseCompanyCaseId",
              },
            },
            accounts: {
              label: "Accounts", type: "searchmodal", slot: 'targets',
              subscribe: {
                'onCreate': {
                  'model': 'CaseAccount',
                  'inputField': 'accounts',
                  'target': 'account'
                },
                'onDelete': {
                  'model': 'CaseAccount',
                  'inputField': 'accounts',
                  'target': 'account'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "accounts",
                objectName: "account",
                pageTitle: "Accounts",
                pageIcon: "store",
                listQueryId: "caseTargetSearchAccounts",
                responseFieldName: "searchAccounts",
                createMutationId: "createCaseAccount",
                deleteQueryId: "deleteCaseAccount",
                deleteQueryIdField: "relateRecordId",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Case?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  name: {label: "Name", sortable: false},
                  createdAt: {label: "Created", sortable: false},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                fuseSearch: null,

                relateRecordInput: {caseAccountAccountId: null, caseAccountCaseId: null},
                relateRecordInputField: "caseAccountAccountId",
                relateRecordRouteField: "caseAccountCaseId",
                // formatResponse: (data) => {
                //   this.$c.log(data);
                //   let result = [];
                //   let responseKey = 'searchAccounts';
                //   if (data && data[responseKey] !== 'undefined') {
                //     let items = data[responseKey].items;
                //     items.forEach((item) => {
                //       item.name = item.account.name;
                //       result.push(item);
                //     })
                //   }
                //   return result;
                // },
                //subscriptions: {}
              },
            },
            services: {
              label: "Services", type: "searchmodal", slot: 'targets',
              subscribe: {
                'onCreate': {
                  'model': 'CaseService',
                  'inputField': 'services',
                  'target': 'service'
                },
                'onDelete': {
                  'model': 'CaseService',
                  'inputField': 'services',
                  'target': 'service'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "services",
                objectName: "service",
                pageTitle: "Services",
                pageIcon: "store",
                listQueryId: "caseTargetSearchServices",
                responseFieldName: "searchServices",
                createMutationId: "createCaseService",
                deleteQueryId: "deleteCaseService",
                deleteQueryIdField: "relateRecordId",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Case?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  name: { label: "Name", sortable: false },
                  createdAt: { label: "Created", sortable: false},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                fuseSearch: null,
                relateRecordInput: {caseServiceServiceId: null, caseServiceCaseId: null},
                relateRecordInputField: "caseServiceServiceId",
                relateRecordRouteField: "caseServiceCaseId",
              },
            },
            products: {
              label: "Products", type: "searchmodal", slot: 'targets',
              subscribe: {
                'onCreate': {
                  'model': 'CaseProduct',
                  'inputField': 'products',
                  'target': 'product'
                },
                'onDelete': {
                  'model': 'CaseProduct',
                  'inputField': 'products',
                  'target': 'product'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "products",
                objectName: "product",
                pageTitle: "Products",
                pageIcon: "store",
                listQueryId: "caseTargetSearchProducts",
                responseFieldName: "searchProducts",
                createMutationId: "createCaseProduct",
                deleteQueryId: "deleteCaseProduct",
                deleteQueryIdField: "relateRecordId",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Case?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  name: { label: "Name", sortable: false },
                  createdAt: { label: "Created", sortable: false},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  sort: 'createdAt',
                  sortDir: 'desc',
                  perPage: 10,
                },
                fuseSearch: null,
                relateRecordInput: {caseProductProductId: null, caseProductCaseId: null},
                relateRecordInputField: "caseProductProductId",
                relateRecordRouteField: "caseProductCaseId",
              },
            },
            salesreps: {
              label: "SalesReps", type: "searchmodal", slot: 'targets',
              subscribe: {
                'onCreate': {
                  'model': 'CaseSalesRep',
                  'inputField': 'salesreps',
                  'target': 'salesrep'
                },
                'onDelete': {
                  'model': 'CaseSalesRep',
                  'inputField': 'salesreps',
                  'target': 'salesrep'
                }
              },
              list: {
                hideNewRecordButton: true,
                hideListHeader: true,
                editPath: "salesreps",
                objectName: "salesrep",
                pageTitle: "Sales Rep",
                pageIcon: "store",
                listQueryId: "caseTargetSearchSalesReps",
                responseFieldName: "searchSalesReps",
                createMutationId: "createCaseSalesRep",
                deleteQueryId: "deleteCaseSalesRep",
                deleteQueryIdField: "relateRecordId",
                targetName: "given_name",
                deleteMessageTitle: "Are you sure you want to remove {objectName} from this Case?",
                deleteMessageText: "",
                linkRows: false,
                itemActions: [
                  {
                    class: "md-just-icon md-simple md-warning",
                    classAdded: "item.added? 'check_circle' : 'md-warning'",
                    icon: "post_add",
                    iconAdded: "check_circle",
                    click: "handleAdd"
                  }
                ],
                columns: {
                  given_name: { label: "Given Name", sortable: false },
                  createdAt: { label: "Created", sortable: false},
                },
                perPageOptions: [5, 10, 20, 25, 50],
                defaults: {
                  perPage: 10,
                  sort: 'id',
                  sortDir: 'desc',
                },
                fuseSearch: null,
                relateRecordInput: {caseSalesRepSalesrepId: null, caseSalesRepCaseId: null },
                relateRecordInputField: "caseSalesRepSalesrepId",
                relateRecordRouteField: "caseSalesRepCaseId",
              },
            },
          }
        },
        form: {
          caseTemplateId: "",
          id: "",
          subject: "",
          internal: false,
          priority: "Normal",
          alertMessage: "",
          rushReason: "",
          origin: "",
          type: "",
          status: "New",
          quickNote: "",
          caseUserId: "",
          caseTeamId: "",
          casePersonId: "",
          isCompleteInOrder: false,

          companies: [],
          accounts: [],
          services: [],
          products: [],
          salesreps: [],
        },
        messagesList: {
          editPath: "messages",
          pageTitle: "Messages",
          pageIcon: "work",
          listQueryId: "searchCaseMessages",
          responseFieldName: "searchMessages",
          deleteQueryId: "deleteMessage",
          columns: {
            // id: { label: "ID", sortable: true },
            createdAt: { label: "Created", sortable: true },
            subject: { label: "Subject", sortable: true },
            from: { label: "From", sortable: true },
            to: { label: "To", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 100,
          },
          fuseSearch: null,
        },
        tasks: [],
        tasksList: {
          hideListHeader: true,
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "input",
              click: "handleEdit",
              isDisabled: false,
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete",
              isDisabled: false,
            }
          ],
          editPath: "tasks",
          pageTitle: "Tasks",
          pageIcon: "assignment_ind",
          listQueryId: "searchCaseTasks",
          responseFieldName: "searchTasks",
          deleteQueryId: "deleteTask",
          deleteMessageTitle: "Are you sure you want to delete {objectName}?",
          deleteMessageText: "",
          deleteMessageNameFields: ['subject'],
          columns: {
            group: { label: "Group" },
            subject: { label: "Task", sortable: true },
            status: { label: "Status", sortable: true },
            user: { label: "Assignee", sortable: true },
            dateDue: { label: "dateDue", sortable: true },
            quickNote: { label: "Quick Note", sortable: true }
          },
          fuseSearch: null,
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0,
            perPageMaxLimit: 9999
          },
          tableData: [],
          searchedData: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchTasks && data.searchTasks.items.length) {
              result = data.searchTasks.items;
            }
            return result;
          },
        },
        relateTasksList: {
          hideListHeader: true,
          skipCardLayout: true,
          activeFlag: true,
          editPath: "tasks",
          pageTitle: "Add Task",
          pageIcon: "assignment_ind",
          listQueryId: "searchTaskStepsLists",
          createMutationId: "createTask",
          deleteQueryId: "deleteTask",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "playlist_add",
              iconAdded: "check_circle",
              click: "handleAddTask"
            }
          ],
          columns: {
            subject: { label: "Subject", sortable: true },
            type: { label: "Type", sortable: true },
            priority: { label: "Priority", sortable: true },
            createdAt: { label: "createdAt", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            let responseKey = 'searchTasks';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                result.push(item);
              })
            }
            return result;
          },
        },
        relateCaseTasksList: {
          hideListHeader: true,
          skipCardLayout: true,
          activeFlag: true,
          editPath: "tasks",
          pageTitle: "Add Task",
          pageIcon: "assignment_ind",
          listQueryId: "searchTaskStepsLists",
          createMutationId: "createTask",
          deleteQueryId: "deleteTask",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "playlist_add",
              iconAdded: "check_circle",
              click: "addTaskToCaseTemplate"
            }
          ],
          columns: {
            subject: { label: "Subject", sortable: true },
            type: { label: "Type", sortable: true },
            priority: { label: "Priority", sortable: true },
            createdAt: { label: "createdAt", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            let responseKey = 'searchTasks';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                result.push(item);
              })
            }
            return result;
          },
        },
        mergeCaseList: {
          showRelatedDialog: false,
          editPath: "cases",
          pageTitle: "Select a Destination Case",
          pageIcon: "merge_type",
          sourceCaseId: this.$route.params.id,
          sourceCaseSubject: "",
          listQueryId: "searchCases",
          updateCaseMutationId: "updateCase",
          updateMessageMutationId: "updateMessage",
          updateNoteMutationId: "updateNote",
          mergeMessageTitle: "Are you sure you wish to merge the following:\n Source: {sourceCase} \n Destination: {objectName}?",
          mergeMessageText: "",
          mergeMessageNameFields: ['subject'],
          mergeCaseStatus: "Merged",
          columns: {},
          fuseSearch: null,
          pagination: {
            perPage: 999,
            currentPage: 1,
            perPageOptions: [],
            total: 0
          },
          tableData: [],
          sourceCaseMessagesList: [],
          sourceCaseNotesList: [],
        },
        linkedCasesList: {
          showRelatedDialog: false,
          hideListHeader: true,
          linkRows: true,
          editPath: "cases",
          pageTitle: "Linked Cases",
          listQueryId: "searchCaseLinkCustoms",
          responseFieldName: "searchCaseLinks",
          //listQueryTarget: "searchCaseLinks",
          deleteQueryId: "deleteCaseLink",
          deleteQueryIdField: "caseLinkLinkCaseId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Case?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          //hideItemActions: this.$Session.isAdminGroupMember ? false : true,
          itemActions: [
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          columns: {
            "esData.linkCase.subject": { label: "Subject", esNested: true, sortable: false },
            "esData.linkCase.status": { label: "Status", esNested: true, sortable: false },
            "esData.linkCase.user": { label: "Assignee", esNested: true, sortable: false, nested:["given_name","family_name"] },
            "esData.linkCase.type": { label: "Type", esNested: true, sortable: false },
            reason: { label: "Reason", sortable: false },
            createdAt: { label: "Created", sortable: true },
          },
          //hyperlink config based on admin role
          linkConfigs: this.$Session.isAdminGroupMember ? [
            {
              name: 'subject',
              hrefCallback: (column, name, item) => {
                return '#/cases/' + item.id;
              },
              titleCallback: (column, name, item) => {
                return item.subject;
              },
            },
            {
              name: 'assignee',
              hrefCallback: (column, name, item) => {
                return '#/users/' + (item.user && item.user.id ? item.user.id : "" );
              },
              titleCallback: (column, name, item) => {
                const assignee = item.user && item.user.given_name && item.user.family_name ? `${item.user.given_name} ${item.user.family_name}` : "";
                return assignee;
              },
            }
          ] : [
            {
              name: 'subject',
              hrefCallback: (column, name, item) => {
                return '#/cases/' + item.id;
              },
              titleCallback: (column, name, item) => {
                return item.subject;
              },
            }
          ],
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          skipLinkedCases: [],
          addRelatedCases: [],
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchCaseLinks && data.searchCaseLinks.items && data.searchCaseLinks.items.length) {
              //hide action column on list for Non-Admin user
              if (this.$Session && (!this.$Session.isAdminGroupMember || this.$Session.isAdminGroupMember == false)) {
                this.linkedCasesList.hideItemActions = true;
              }

              let activeCaseId = this.$route.params.id;

              data.searchCaseLinks.items.forEach((item) => {
                let esData = JSON.parse(item.esData);

                let caseData = false;
                let esDataCaseKey = false;

                //Show vice-verse Case if linkCase.id matches activeCaseId
                if (esData.linkCase.id === activeCaseId) {
                  let temp1 = esData.case;
                  let temp2 = esData.linkCase;
                  esData.case = temp2;
                  esData.linkCase = temp1;
                }

                if (esData.linkCase.id === activeCaseId) {
                  caseData = esData.linkCase;
                  esDataCaseKey = 'linkCase';
                } else if (esData.case.id === activeCaseId) {
                  caseData = esData.case;
                  esDataCaseKey = 'case';
                }

                if (caseData) {

                  if (!caseData.team) {
                    caseData.team = {
                      name: ''
                    };
                  }

                  if (!caseData.template) {
                    caseData.template = {
                      subject: ''
                    };
                  } else {
                    caseData.template.subject = caseData.template.subject.replace(/_/g, ' ');
                  }

                  item.caseLinkLinkCaseId = item.id;
                  caseData.reason = item.reason;
                  //remove _ from status
                  caseData.status = caseData.status ? caseData.status.replace(/\_/g, ' ') : '';
                  //set date format for createdAt
                  caseData.createdAt = moment(String(item.createdAt)).format('YYYY-MM-DD');

                  esData[esDataCaseKey] = caseData;
                  item.esData = JSON.stringify(esData);

                  //navigate to clicked Case
                  item.id = esData.linkCase.id;
                  //set name to show on delete action alert
                  item.name = esData.linkCase.subject;
                }
                //get array of already linked cases
                // [i]this could use caseData.id if we switch to pulling data from both slots
                this.linkedCasesList.skipLinkedCases.push(item.linkCase.id);
                result.push(item);
              })
            }
            return result.reverse();
          }
        },
        relateCasesList: {
          searchRecordsInput: false, //disable search input
          showModalDropdown: true,
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "cases",
          pageTitle: "Select the Cases you wish to link",
          pageIcon: "insert_link",
          listQueryId: "searchCaseCustoms",
          responseFieldName: "searchCases",
          createMutationId: "createCaseLink",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleCaseLink"
            }
          ],
          columns: {
            subject: { label: "Subject", sortable: true },
            status: { label: "Status", sortable: true },            
            assignee: { label: "Assignee", sortable: true },
            type: { label: "Type", sortable: true },
            createdAt: { label: "Created", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          caseLinkReasonOptions: [],
          formatResponse: (data) => {
            let result = [];

            if (data && data.searchCases && data.searchCases.items && data.searchCases.items.length) {
              //add caseLinkReason to pass in ElasticList dropdown
              let linkReason = [];
              data.listCaseLinkReasonEnum.enumValues.forEach(el => {
                linkReason.push(el.name);
              });
              this.relateCasesList.caseLinkReasonOptions = linkReason;

              data.searchCases.items.forEach((item) => {
                // if(this.$route.params.id != item.id) {
                //   if(!this.linkedCasesList.skipLinkedCases.includes(item.id)) {
                    item.assignee = item.user ? item.user.given_name + ' ' + item.user.family_name : '';
                    item.type = item.template ? item.template.subject : '';
                    //remove _ from status
                    item.status = item.status ? item.status.replace(/\_/g, ' ') : '';

                    result.push(item);
                //   }
                // }
              });

              //add items to relatedCasesList to show on dialog again after delete action
              // if(this.linkedCasesList && this.linkedCasesList.addRelatedCases && this.linkedCasesList.addRelatedCases.length) {
              //   this.linkedCasesList.addRelatedCases.forEach((el) => {
              //     result.push(el);
              //   });
              // }
            }
            return result;
          },
        },
        groupIndex: 0,
        orderIndex: 0,
        messagesAndNotes: [],
        messagesAndNotesFiltered: [],
        messagesAndNotesPage: 1,
        messagesAndNotesItemsPerPage: 50,
        isDeepLinkLoadInProgress: false,
        activeEditorTab: 'tab-note',
        activeFeedAndTasksTabId: 'tab-message',
        defaultActiveCollapseIndex: 1,
        isChangeActiveTab: false,
        atMentionsUserList: [],
        subscriptions: {
          onUpdateCase: {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateCase");
              this.$c.log(eventData);
              this.recordData.status = eventData.value.data.onUpdateCase.status;
              if (this.recordData.id === eventData.value.data.onUpdateCase.id) {
                (($this) => {                
                    const user = this.$reduce(eventData, 'value.data.onUpdateCase.user');
                    if (user === null) {
                        $this.searchTerm = ''
                        this.form.caseUserId = null;
                    }
                })(this.formConfig.fields.caseUserId);
              }
            }
          },
          onCreateChange: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateChange");
              this.$c.log(eventData);
              if((eventData.value.data.onCreateChange.modelName == "Case") && (eventData.value.data.onCreateChange.modelId == this.$route.params.id)) {
                /**
                 * <Case details page><Case Feeds> Logged in user name is showing on Case feed until user refresh the page even though the case status change activity perform by another user
                 * Added second delay so that data set properly
                 */
                window.setTimeout(async() => {
                  await this.getChangeDetails()
                  this.updateFormAfter(this.updateFormData);
                }, 1000)
              }
            },
          },
          onCreateMessage: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateMessage");
              this.$c.log(eventData);
              if (eventData.value.data.onCreateMessage.case && eventData.value.data.onCreateMessage.case.id == this.$route.params.id) {
                this.recordData.messages.items.unshift(eventData.value.data.onCreateMessage);
                this.updateFormData.getCase = this.recordData;
                this.updateFormAfter(this.updateFormData);
              }              
            }
          },
          onCreateNote: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateNote");
              this.$c.log(eventData);
              this.recordData.notes.items.unshift(eventData.value.data.onCreateNote);
              this.updateFormData.getCase = this.recordData;
              this.updateFormAfter(this.updateFormData);
            }
          },
          onCreateRelation: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateRelation");
              this.$c.log(eventData);
              // adding timeout to make sure attachments get properly updated
              setTimeout(() => {
                this.updateFormData.getCase = this.recordData;
                this.updateFormAfter(this.updateFormData);
                this.$refs.attachmentsListRefs.onSearch();
              }, 2000)
            }
          },
          onUpdateAttachment: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateAttachment");
              this.$c.log(eventData);
              this.updateFormData.getCase = this.recordData;
              this.updateFormAfter(this.updateFormData);
            }
          },
          onDeleteNote: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onDeleteNote");
              this.$c.log(eventData);
              let indexToDelete = _.findIndex(this.recordData.notes.items, {
                id: eventData.value.data.onDeleteNote.id
              });
              this.recordData.notes.items.splice(indexToDelete, 1);
              this.updateFormData.getCase = this.recordData;
              this.updateFormAfter(this.updateFormData);
            }
          },
          onUpdateNote: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateNote");
              this.$c.log(eventData);
              let indexToUpdate = _.findIndex(this.recordData.notes.items, {
                id: eventData.value.data.onUpdateNote.id
              });
              this.recordData.notes.items[indexToUpdate].note = eventData.value.data.onUpdateNote.note;
              this.recordData.notes.items[indexToUpdate].updatedAt = eventData.value.data.onUpdateNote.updatedAt;
              setTimeout(() => {
                this.updateFormData.getCase = this.recordData;
                this.updateFormAfter(this.updateFormData);
              }, 250)
            }
          },
          onUpdateMessage: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateMessage");
              this.$c.log(eventData);
              let indexToUpdate = _.findIndex(this.recordData.messages.items, {
                id: eventData.value.data.onUpdateMessage.id
              });
              this.recordData.messages.items[indexToUpdate].updatedAt = eventData.value.data.onUpdateMessage.updatedAt;
              setTimeout(() => {
                this.updateFormData.getCase = this.recordData;
                this.updateFormAfter(this.updateFormData);
              }, 250)
            }
          },
          onCreateComment: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateComment");
              this.$c.log(eventData);
              this.newComment = [];
              this.newAddedComment = [];
              const commentId = eventData.value.data.onCreateComment.id

              let commentOn = 'note'
              let commentObject = 'notes'

              if (eventData.value.data.onCreateComment.note) {
                this.newComment.push({'type':'note', 'commentId':eventData.value.data.onCreateComment.id, 'noteId':eventData.value.data.onCreateComment.note.id})
                this.newAddedComment = this.newComment
              }

              if (eventData.value.data.onCreateComment.message) {
                commentOn = 'message';
                commentObject = 'messages';
                this.newComment.push({'type':'message', 'commentId':eventData.value.data.onCreateComment.id, 'messageId': eventData.value.data.onCreateComment.message.id })
                this.newAddedComment = this.newComment
              } else if (eventData.value.data.onCreateComment.task) {
                commentOn = 'task';
                commentObject = 'tasks';
              }

              if (eventData.value.data.onCreateComment.parentComment) {
                commentOn = 'parentComment';
                commentObject = 'tasks';
                this.newComment.push({'type':'comment', 'commentId':eventData.value.data.onCreateComment.id, 'parentCommentId': eventData.value.data.onCreateComment.parentComment.id})
                this.newAddedComment = this.newComment
              }

              if (
                !eventData.value.data.onCreateComment[commentOn]
                || !this.recordData[commentObject]
              ) {
                return
              }

              if ('parentComment' == commentOn) {
                // get parent comment id
                const parentCommentId = eventData.value.data.onCreateComment.parentComment.id
                
                // get all recordData tasks
                const tasks = this.$reduce(this, 'recordData.tasks.items') || []

                // scan all tasks
                for (const _task of tasks) {
                  // get all task comments
                  const comments = this.$reduce(_task, 'comments.items') || []

                  // scan all comments
                  for (const _comment of comments) {
                    // if comment is parent comment then add as child comment
                    if (_comment.id == parentCommentId) {
                      if (!_comment.comments || !_comment.comments.items) {
                        _comment.comments = { items: [] };
                      }
                      _comment.comments.items.unshift(eventData.value.data.onCreateComment)
                    }
                  }
                }
              }

              let addToId = eventData.value.data.onCreateComment[commentOn].id;
              let indexToAdd = _.findIndex(this.recordData[commentObject].items, {
                id: addToId
              });

              if (
                (indexToAdd != -1)
                && this.recordData[commentObject].items[indexToAdd]
                && this.recordData[commentObject].items[indexToAdd].comments
                && this.recordData[commentObject].items[indexToAdd].comments.items
              ) {
                if (!this.recordData[commentObject].items[indexToAdd].comments) {
                  this.recordData[commentObject].items[indexToAdd].comments = { items:[] }
                }
                if (!this.recordData[commentObject].items[indexToAdd].comments.items) {
                  this.recordData[commentObject].items[indexToAdd].comments.items = []
                }
                this.recordData[commentObject].items[indexToAdd].comments.items.unshift(eventData.value.data.onCreateComment);
              }

              this.updateFormData.getCase = this.recordData;
              this.updateFormAfter(this.updateFormData);
            }
          },
          onDeleteComment: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onDeleteComment");
              this.$c.log(eventData);

              const commentId = eventData.value.data.onDeleteComment.id

              let commentOn = 'note'
              let commentObject = 'notes'

              if (eventData.value.data.onDeleteComment.message) {
                commentOn = 'message'
                commentObject = 'messages'
              }

              if (eventData.value.data.onDeleteComment.parentComment) {
                commentOn = 'parentComment'
                commentObject = 'tasks'
              }

              if (
                !eventData.value.data.onDeleteComment[commentOn]
                || !this.recordData[commentObject]
              ) {
                return
              }
              
              if ('parentComment' == commentOn) {
                // get parent comment id
                const parentCommentId = eventData.value.data.onDeleteComment.parentComment.id
                
                // get all recordData tasks
                const tasks = this.$reduce(this, 'recordData.tasks.items') || []

                // scan all tasks
                for (const _task of tasks) {
                  // get all task comments
                  const comments = this.$reduce(_task, 'comments.items') || []

                  // scan all comments
                  for (const _comment of comments) {
                    // if comment is parent comment then add as child comment
                    if (_comment.id == parentCommentId) {
                      // get all child comments
                      const childComments = this.$reduce(_comment, 'comments.items') || []
                      const childCommentIndex = childComments.findIndex(_childComment => {
                        return _childComment.id == eventData.value.data.onDeleteComment.id
                      })
                      if (-1 != childCommentIndex) {
                        _comment.comments.items.splice(childCommentIndex, 1)
                      }
                    }
                  }
                }
              }

              let deleteFromId = eventData.value.data.onDeleteComment[commentOn].id
              let indexToDelete = _.findIndex(this.recordData[commentObject].items, {
                id: deleteFromId
              })
              
              if (
                -1 !== indexToDelete
                && this.recordData[commentObject].items[indexToDelete]
                && this.recordData[commentObject].items[indexToDelete].comments
                && this.recordData[commentObject].items[indexToDelete].comments.items
              ) {
                const index = _.findIndex(this.recordData[commentObject].items[indexToDelete].comments.items, {
                  id: eventData.value.data.onDeleteComment.id
                })
                if (-1 != indexToDelete) {
                  this.recordData[commentObject].items[indexToDelete].comments.items.splice(index, 1)
                }
              }              
              
              this.updateFormData.getCase = this.recordData;
              this.updateFormAfter(this.updateFormData);
            }
          },
          onUpdateComment: {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateComment")
              this.$c.log(eventData)

              const commentId = eventData.value.data.onUpdateComment.id

              let commentOn = 'note'
              let commentObject = 'notes'

              if (eventData.value.data.onUpdateComment.message) {
                commentOn = 'message'
                commentObject = 'messages'
              }

              if (eventData.value.data.onUpdateComment.parentComment) {
                commentOn = 'parentComment'
                commentObject = 'tasks'
              }

              //ATLAS-553 sort the feed by updatedAt
              if (eventData.value.data.onUpdateComment.task && eventData.value.data.onUpdateComment.parentComment == null) {
                // get parent comment id
                const CommentId = eventData.value.data.onUpdateComment.id
                
                // get all recordData tasks
                const tasks = this.$reduce(this, 'recordData.tasks.items') || []

                const taskIndex = tasks.findIndex(taskItem => {
                  return taskItem.id == eventData.value.data.onUpdateComment.task.id
                })
                // scan all tasks
                for (const _task of tasks) {
                  // get all task comments

                  if(_task.id === eventData.value.data.onUpdateComment.task.id){

                    const comments = this.$reduce(_task, 'comments.items') || []

                    let commentIndex = comments.findIndex(commentItem => {
                      return commentItem.id == eventData.value.data.onUpdateComment.id
                    })

                    for (const _comment of comments) {                    
                      if(_comment.id === eventData.value.data.onUpdateComment.id){
                        if(-1 != taskIndex && -1 != commentIndex){
                        this.recordData.tasks.items[taskIndex].comments.items[commentIndex].updatedAt = eventData.value.data.onUpdateComment.updatedAt;                       
                        }                      
                      }
                    }
                  }
                }
                setTimeout(() => {
                  this.updateFormData.getCase = this.recordData;
                  this.updateFormAfter(this.updateFormData);
                }, 250)
              }
              
              if (
                !eventData.value.data.onUpdateComment[commentOn]
                || !this.recordData[commentObject]
              ) {
                return
              }
              
              if ('parentComment' == commentOn) {
                // get parent comment id
                const parentCommentId = eventData.value.data.onUpdateComment.parentComment.id
                
                // get all recordData tasks
                const tasks = this.$reduce(this, 'recordData.tasks.items') || []

                // scan all tasks
                for (const _task of tasks) {
                  // get all task comments
                  const comments = this.$reduce(_task, 'comments.items') || []

                  // scan all comments
                  for (const _comment of comments) {
                    // if comment is parent comment then add as child comment
                    if (_comment.id == parentCommentId) {
                      // get all child comments
                      const childComments = this.$reduce(_comment, 'comments.items') || []
                      const childCommentIndex = childComments.findIndex(_childComment => {
                        return _childComment.id == eventData.value.data.onUpdateComment.id
                      })
                      if (-1 != childCommentIndex) {
                        _comment.comments.items[childCommentIndex] = eventData.value.data.onUpdateComment
                        _comment.comments.items[childCommentIndex].updatedAt = eventData.value.data.onUpdateComment.updatedAt
                      }
                    }
                  }
                }
              }

              let updateFromId = eventData.value.data.onUpdateComment[commentOn].id
              let indexToUpdate = _.findIndex(this.recordData[commentObject].items, {
                id: updateFromId
              })
              
              if (
                -1 !== indexToUpdate
                && this.recordData[commentObject].items[indexToUpdate]
                && this.recordData[commentObject].items[indexToUpdate].comments
                && this.recordData[commentObject].items[indexToUpdate].comments.items
              ) {
                const index = _.findIndex(this.recordData[commentObject].items[indexToUpdate].comments.items, {
                  id: eventData.value.data.onUpdateComment.id
                })
                if (-1 != indexToUpdate) {
                  this.recordData[commentObject].items[indexToUpdate].comments.items[index] = eventData.value.data.onUpdateComment
                  this.recordData[commentObject].items[indexToUpdate].comments.items[index].updatedAt = eventData.value.data.onUpdateComment.updatedAt
                }
              }
              
              setTimeout(() => {
                this.updateFormData.getCase = this.recordData;
                this.updateFormAfter(this.updateFormData);
              }, 250)
            }
          },
          onCreateTask: {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateTask");
              this.$c.log(eventData);
              const task = this.$reduce(eventData, 'value.data.onCreateTask');
              if (task && task.case && task.case.id && task.case.id == this.$route.params.id) {
                
                // check and set table data if it does not exist
                const tableData = this.$reduce(this, 'tasksList.tableData');
                if (!tableData || !tableData.length) {
                  this.$set(this.tasksList, 'tableData', []);
                }
                
                // check and set existing task items if it does not exist
                let existingTaskItems = this.$reduce(this, 'existingTasks.items');
                if (!existingTaskItems || !existingTaskItems.length) {
                  this.$set(this.existingTasks, 'items', []);
                }
                
                // find task in existing tasks list
                let taskItems = this.$reduce(this, 'recordData.tasks.items');
                if (!taskItems || !taskItems.length) {
                  this.$set(this.recordData.tasks, 'items', []);
                }
                
                const updatedTaskIndex = taskItems.findIndex(_item => _item.id == task.id);
                if (-1 == updatedTaskIndex) {
                  this.recordData.tasks.items.unshift(task);
                } else {
                  this.$set(this.recordData.tasks.items, updatedTaskIndex, task);
                }
                
                // add or update item in existing task items
                const existingTaskIndex = this.existingTasks.items.findIndex(_item => _item.id == task.id);
                if (-1 == existingTaskIndex) {
                  this.existingTasks.items.unshift(task);
                } else {
                  this.$set(this.existingTasks.items, existingTaskIndex, task);
                }
                
                // // add or update item in tableData
                const taskIndex = this.tasksList.tableData.findIndex(_task => _task.id == task.id);
                if (-1 == taskIndex) {
                  this.tasksList.tableData.unshift(task);
                } else {
                  this.$set(this.tasksList.tableData, taskIndex, task);
                }
                
                this.$set(this.tasksList, 'forceMountedRefresh', this.tasksList.tableData.length);
                // this.refresh();
                
              }
            }
          },
          onUpdateTask: {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateTask");
              this.$c.log(eventData);
              const task = this.$reduce(eventData, 'value.data.onUpdateTask');
              if (task && task.case && task.case.id && task.case.id == this.$route.params.id) {
                
                // check and set table data if it does not exist
                const tableData = this.$reduce(this, 'tasksList.tableData');
                if (!tableData || !tableData.length) {
                  this.$set(this.tasksList, 'tableData', []);
                }
                
                // check and set existing task items if it does not exist
                let existingTaskItems = this.$reduce(this, 'existingTasks.items');
                if (!existingTaskItems || !existingTaskItems.length) {
                  this.$set(this.existingTasks, 'items', []);
                }
                
                // find task in existing tasks list
                let taskItems = this.$reduce(this, 'recordData.tasks.items');
                if (!taskItems || !taskItems.length) {
                  this.$set(this.recordData.tasks, 'items', []);
                }
                
                const updatedTaskIndex = taskItems.findIndex(_item => _item.id == task.id);
                if (-1 == updatedTaskIndex) {
                  this.recordData.tasks.items.unshift(task);
                } else {
                  this.$set(this.recordData.tasks.items, updatedTaskIndex, task);
                }
                
                // add or update item in existing task items
                const existingTaskIndex = this.existingTasks.items.findIndex(_item => _item.id == task.id);
                if (-1 == existingTaskIndex) {
                  this.existingTasks.items.unshift(task);
                } else {
                  this.$set(this.existingTasks.items, existingTaskIndex, task);
                }
                
                // // add or update item in tableData
                const taskIndex = this.tasksList.tableData.findIndex(_task => _task.id == task.id);
                if (-1 == taskIndex) {
                  this.tasksList.tableData.unshift(task);
                } else {
                  this.$set(this.tasksList.tableData, taskIndex, task);
                }
                
                this.$set(this.tasksList, 'forceMountedRefresh', this.tasksList.tableData.length);
                // this.refresh();
                window.$bus.$emit('caseTaskView.forceUpdate');
              }
            }
          },
          onDeleteTask: {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onDeleteTask");
              this.$c.log(eventData);
              let indexToDelete = _.findIndex(this.tasksList.tableData, {
                id: eventData.value.data.onDeleteTask.id
              });
              if (-1 != indexToDelete) {
                this.tasksList.tableData.splice(indexToDelete, 1);
              }
              // this.$set(this.tasksList, 'forceMountedRefresh', this.tasksList.tableData.length);
              this.$set(this.tasksList, 'dataNeedsUpdate', (new Date()).getTime());
              let indexToDeleteFromExistingTasks = _.findIndex(this.existingTasks.items, {
                id: eventData.value.data.onDeleteTask.id
              });
              if (-1 != indexToDeleteFromExistingTasks) {
                this.existingTasks.items.splice(indexToDeleteFromExistingTasks, 1);
              }
            }
          },
          onCreateTaskStep: {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onCreateTaskStep");
              this.$c.log(eventData);
              this.handleTaskStepNotification(eventData);
            }
          },
          onUpdateTaskStep: {
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onUpdateTaskStep");
              this.$c.log(eventData);
              this.handleTaskStepNotification(eventData);
            }
          },
          'onCreateCaseLink': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateCaseLink');
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onCreateCaseLink;

              if (this.$route.params.id === eventRecord.case.id) {
                this.$c.log('SUBSCRIPTION MATCH!: onCreateCaseLink');
                //refresh the list
                // delay needs to be sufficient to let list properly reload
                window.setTimeout(() => {
                  this.$refs.linkedCasesListRef.refresh();
                }, 3000);
                //Force a refresh on the ConfigForm component
                this.formConfig.refreshRecordData = true;
              }
            }
          },
          'onDeleteCaseLink': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: eventData => {
              this.$c.log("SUBSCRIPTION Trigger: onDeleteCaseLink");
              this.$c.log("eventData: ", eventData);
              let eventRecord = eventData.value.data.onDeleteCaseLink;
              if (this.$route.params.id === eventRecord.case.id) {
                this.$c.log('SUBSCRIPTION MATCH!: onDeleteCaseLink');
                //refresh the list
                window.setTimeout(() => {
                  this.$refs.linkedCasesListRef.refresh();
                }, 300);
                //Force a refresh on the ConfigForm component
                this.formConfig.refreshRecordData = true;
              }
            }
          },
        }, 
        isUploadDialogOpen: false,
        docTypes: [], 
        noteId: null,
        attachmentData: [],
        editAttachmentId: null,
        editAttachmentInternal: null
      }
    },
    validations() {
      return {
        form: {
          id: {},
          subject: {required, minLength: minLength(3),
              async isUnique(value) {
                if (value.trim().length < 3) {
                  return true;
                }
                const timeoutInterval = this.isFirstTimeReservedNameCheck ? 0 : 3000;
                this.isFirstTimeReservedNameCheck = false;
                clearTimeout(this.reservedNameValidatorTimeoutId);
                return new Promise(async (resolve, reject) => {
                  this.reservedNameValidatorTimeoutId = setTimeout(async () => {
                    const valueTrimmed = value.trim();
                    const index = this.workflowCaseTempList.findIndex(_item => {
                      return _item.name.toLowerCase() == valueTrimmed.toLowerCase();
                    });
                    if (-1 === index) {
                      return resolve(true);
                    }else if(this.recordData && this.recordData.isSystemCreated){
                      return resolve(true);
                    }
                    return reject(false);
                  }, timeoutInterval);
                });
              }         
          },
          internal: {},
          caseTemplateId: {},
          priority: {},
          alertMessage: {},
          rushReason: (this.form && this.form.priority === 'Rush') ? {required, minLength: minLength(3)} : {},
          origin: {required},
          type: {required},
          status: {},
          quickNote: {},
          caseUserId: {},
          caseTeamId: {},
          casePersonId: {},
          isCompleteInOrder: {},
          companies: {},
          accounts: {},
          services: {},
          products: {},
          salesreps: {},          
        },
        reply: {
          to: { required, CustomEmailValidator },
          cc: { CustomEmailValidator },
          bcc: { CustomEmailValidator }
        },
        forward: {
          to: { required, CustomEmailValidator },
          cc: { CustomEmailValidator },
          bcc: { CustomEmailValidator }
        }
      }
    },
    beforeMount() {
      // run the function to get the change data
      this.getChangeDetails();
      this.generateMessagesFilter();
    },
    beforeRouteLeave(to, from, next) {
      this.$notifyClear(this.noticationTimeStamp);
      this.noticationTimeStamp = [];
      next();
    },
    async mounted() {
      // respond to task click event on CaseTaskViewTaskComponent
      window.$bus.$on('caseTaskView.task.click', (task) => this.onCaseTaskViewTaskClick(task));

      //if tab navigation required
      if('tasks' == this.$route.meta.tab) {
        this.isChangeActiveTab = true;
        this.activeFeedAndTasksTabId = "tab-tasks";
        this.defaultActiveCollapseIndex = 1;
      }
      const urlHash = this.$route.hash;
      if (urlHash && urlHash.length) {
        this.defaultActiveCollapseIndex = 1;
      }
      this.getUserList();
      let REGEX = /.*-(\w+)/
      let amplifyEnv = aws_exports.aws_content_delivery_bucket.match(REGEX)[1]
      let attachmentBucketPrefix  = "atlasemailattachments-"
      const attachmentBucket = attachmentBucketPrefix+amplifyEnv        
      Storage.configure({
        AWSS3: {
          bucket: attachmentBucket,//Your bucket name;
          region: aws_exports.aws_project_region//Specify the region your bucket was created in;
        }
      });
      this.docTypes = await this.getDocTypes();
      console.log("Record Data => ", this.recordData)
      const that = this;
      setTimeout( () => {
        that.getLinkConfigs();
      }, 2000)  
    },
    methods: {
      showAlertMessageNotification() {
        this.$notifyClear(this.noticationTimeStamp);
        this.noticationTimeStamp = [];

        if (this.recordData && this.recordData.alertMessage) {
          let timeStamp = this.$notify({
            title: "Case Alert",
            message: this.recordData.alertMessage,
            icon: "style",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            timeout: 10000
          });
          this.noticationTimeStamp.push(timeStamp);
        }
      },
      getLinkConfigs() {
        if (this.$Session.isAdminGroupMember) {
          this.linkedCasesList.linkConfigs = [
            {
              name: 'subject',
              hrefCallback: (column, name, item) => {
                return '#/cases/' + item.id;
              },
              titleCallback: (column, name, item) => {
                return item.subject;
              },
            },
            {
              name: 'assignee',
              hrefCallback: (column, name, item) => {
                return '#/users/' + (item.user && item.user.id ? item.user.id : "" );
              },
              titleCallback: (column, name, item) => {
                const assignee = item.user && item.user.given_name && item.user.family_name ? `${item.user.given_name} ${item.user.family_name}` : "";
                return assignee; 
              },
            }
          ]
          if (this.$refs.linkedCasesListRef) {
            this.$refs.linkedCasesListRef.refresh();
          }
        }
      },
      getNoteAttachmentRelations() {
        const relations = this.attachmentRelations
        relations.push({ fromModelType: 'Note', relationNoteId: this.noteId })
        return relations
      },
      /**
       * Handle click event on a task in CaseTaskViewTaskComponent
       * The event is emitted using global window bus
       * @param {Object} task - the task object that was clicked on
       * @return {void}
       */
      onCaseTaskViewTaskClick(task) {
        this.iframeModelId = task.id;
        window.$bus.$emit('sidepanel.tabs.change', 'details');
        window.$bus.$emit('sidepanel.tabs.toggle', 'details', false);
        window.$bus.$emit('sidepanel.open');
      },
      orderedAuditLog: function (items) {
        return _.orderBy(items, 'createdAt', 'desc');
      },
      onShowAuditLog () {
        this.auditLogDialog = true;
      },
      debounceReplyInput: _.debounce(function (e) {
        if(this.recordData && this.$Session.userId) {
          this.autoSaveCaseDraft('reply');
        }
      }, 3000),
      debounceForwardInput: _.debounce(function (e) {
        if(this.recordData && this.$Session.userId) {
          this.autoSaveCaseDraft('forward');
        }
      }, 3000),
      tabChanged (tabId) {
        this.activeEditorTab = tabId;
        let mode = tabId == 'tab-reply' ? 'reply': tabId == 'tab-forward' ? 'forward' : 'note';
        if(this.recordData && mode!= 'note'){
          this.changeTab(mode);
        }else{
          setTimeout(() => 
          { 
            window.$bus.$emit('focusTinyMceEditor', { id: mode});
          }, 300);
        }          
      },
      onFeedAndTasksTabChanged(id) {
        if(!this.isChangeActiveTab) {
          this.activeFeedAndTasksTabId = id;
        } else {
          this.isChangeActiveTab = false;
        }
      },
      draftOwnerFilter (editor) {
        if(this.recordData)
        {
          let owner = this.$Session.user.username;
          return this.recordData.caseDrafts.items.filter(function (item) { 
            return item.owner === owner && item.draftType === editor;
          });
        } else {
          return [];
        }       
      },
      showEditor(mode) {
        console.log("showEditor",mode);
        this.showEditorFlag = true;
        setTimeout(() => 
        { 
          window.$bus.$emit('focusTinyMceEditor', { id: mode});
        }, 300);
        
        let draftItem = this.draftOwnerFilter(mode);
        if (draftItem.length){
          this.loadDraftMessage(mode,JSON.parse(JSON.stringify(draftItem[0]))); 
        }          
        else
          this.onReply(mode,JSON.parse(JSON.stringify(this.defaultItem))); 
      },
      changeTab(mode) {
        console.log("changeTab",mode);
        if(this.blockChangeTab !== true) {
          this.showEditorFlag = true;
          setTimeout(() => 
          { 
            window.$bus.$emit('focusTinyMceEditor', { id: mode});
          }, 300);
          let draftItem = this.draftOwnerFilter(mode);
          if (draftItem.length){
            this.loadDraftMessage(mode,JSON.parse(JSON.stringify(draftItem[0])), true); 
          }          
          else
            this.onReply(mode,JSON.parse(JSON.stringify(this.defaultItem)),true, true);           
        }
        this.blockChangeTab = false;        
      },
      closeEditor(editor) {
        this[editor].body = '';
        window.$bus.$emit('refreshTinyMceEditor', { id: editor, content: '' });
        this.showEditorFlag = false;
          if(editor!='note')
            this.cancelDraft(editor)

        if (editor === 'note') {
          this.attachmentData = [];
        }
      },
      convertToChunks () {
        this.chunkFiles = [];
        let index=-1;
        for (let i=0,j=this.files.length,chunk = 6; i<j; i+=chunk) {
          this.chunkFiles.push(this.files.slice(i,i+chunk));
          index++;
        }
        if(this.files.length%6 != 0)
        {
          for (let i=0,chunk = 6; i<(chunk - this.files.length%chunk); i++) {
            this.chunkFiles[index].push({});
          }
        }
      },
      addFiles(){
        this.$refs.multiplFiles.click();
      },
      handleFileUpload(){
        let selectedFiles = this.$refs.multiplFiles.files;
        this.attachmentOptions = [];
        if(!selectedFiles) return;
        ([...selectedFiles]).forEach(f => {
          this.files.push(f);
          this.attachmentOptions.push({ internal: false });
        });
        this.convertToChunks();
      },
      addFile(e) {
        let droppedFiles = e.dataTransfer.files;
        if(!droppedFiles) return;
        ([...droppedFiles]).forEach(f => {
          this.files.push(f);
        });
        this.convertToChunks();
      },
      removeFile(file){
        this.files = this.files.filter(f => {
          return f != file;
        });
        this.convertToChunks();
      },
      async sendMail(editor) {
        this.promisePending = true;
        const attachmentUuid = uuidv1();
        for(let i=0;i<this.files.length;i++){
          await Storage.put(`${attachmentUuid}/${this.files[i].name}`, this.files[i], {
            contentType: this.files[i].type
          })
            .then (result => console.log(result))
            .catch(err => console.log(err));
        }
        
        let data = {
          // replyToMessageId: this[editor].id,
          subject: this[editor].subject,
          from: this.$Session.user.attributes.email,
          to: this[editor].to,
          body: this[editor].body,
          internal: this[editor].internal ? true : false,
          messageCaseId: this[editor].messageCaseId ? this[editor].messageCaseId : this.$route.params.id,          
          messageUserId: this.$Session.userId
        };

        if(this[editor].id && this[editor].draftType && this[editor].replyToMessageId){
          data.replyToMessageId = this[editor].replyToMessageId
        }else if(this[editor].id){
          data.replyToMessageId = this[editor].id
        }

        if(this.files.length) 
          data['messageAttachmentId'] = attachmentUuid;
        
        data.to = this[editor].to.replace(/;/g, ',');
        data.cc = this[editor].cc ? this[editor].cc.replace(/;/g, ',') : ' ';
        data.bcc = this[editor].bcc ? this[editor].bcc.replace(/;/g, ',') : ' ';

        //added outgoingFlag to get replied/forwarded status for outgoing message
        data.outgoingFlag = editor;
        data.attachmentOptions = JSON.stringify(this.getAttachmentOptions());
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        data['messageOutgoingUpdatedById'] = this.$reduce(this, '$Session.userId');
        
        this.$c.log('gqlRequest data', data);

        let gqlRequest = graphqlOperation(mutations['createMessageOutgoing'], {input: data});
        this.$c.log('gqlRequest', gqlRequest);

        const result = await API.graphql(gqlRequest)
          .then(result => {            
            this.$c.log(result);
            this.snackbar.status = true;
            this.snackbar.content = 'Message Sent Successfully';
            this.snackbar.icon = 'done';
            this.clearEditor(editor);
            this.closeEditor(editor);            
          })
          .catch(error => {
            this.dialog.status = true;
            this.dialog.content = error.errors[0].message;
            this.$c.log(error);
            this.clearEditor(editor);
            this.closeEditor(editor);
          });
        
        this.promisePending = false;
      },
      scrollToHash(hash){
        if(hash) {
          let parentEle = document.getElementById('sidePanelBody');
          if (!parentEle) {
            parentEle = window;
          }

          let element = document.getElementById(hash);
          if(element) {
            const top = element.getBoundingClientRect().top + window.pageYOffset;
            parentEle.scrollTo({
              top, // scroll so that the element is at the top of the view
              behavior: 'smooth' // smooth scroll
            })
          }
        }
      },
      async getUserList() {
        console.log("getUserList function");
        const users = [];
        const limit = 999;
        let hasNext = true;
        let nextToken = 0;
        
        while (hasNext) {
          // fetch users
          const response = await API.graphql(graphqlOperation(queries["searchUsers"], { limit, nextToken }));
          const items = this.$reduce(response, 'data.searchUsers.items') || [];
          
          // format response and add to list
          for (const _item of items) {
            users.push({
              id : _item.id,
              name: _item.given_name +"_"+ _item.family_name,
              email: _item.email
            });
          }
          
          // if number of items is equal to limit then next page is available
          hasNext = limit === items.length;
          nextToken += limit;
        }
        
        // assign users
        this.userListItems = users;
      },
      async sendNote () {
        if(this.noteItem) {
          this.promisePending = true;
          let updateNoteData = {
            id: this.noteItem.id,
            note: this.note.body,
            internal: this.isNoteInternal
          }

          this.getAtMentionUsers (updateNoteData);

          //update data for atMentions key
          if (this.atMentionsUserList && this.atMentionsUserList.length) {
            let atMentionsList = {
              items: this.atMentionsUserList
            };
            updateNoteData.atMentions = JSON.stringify(atMentionsList);
          } else {
            updateNoteData.atMentions = JSON.stringify({});
          }
          
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          updateNoteData['noteUpdatedById'] = this.$reduce(this, '$Session.userId');

          let gqlRequest = graphqlOperation(mutations['updateNote'], {input: updateNoteData});
          this.$c.log('gqlRequest', gqlRequest);

          const result = await API.graphql(gqlRequest)
          .then(async result => {
            this.$c.log(result);
            
            // the mixins use this.attachments
            this.attachments = this.attachmentData
            this.noteId = result.data.updateNote.id;
            await this.add(this.getNoteAttachmentRelations())
            
            this.snackbar.status = true;
            this.snackbar.content = 'Note Updated Successfully';
            this.snackbar.icon = 'done';
            this.noteId = null
            this.attachments = []
            this.placeHolder();
            this.clearNoteEditor();
            this.promisePending = false;
          })
          .catch(error => {
            this.noteId = null
            this.attachments = []
            this.$c.log(error);
            this.dialog.status = true;
            this.dialog.content = error.errors[0].message;
            this.clearNoteEditor();
            this.promisePending = false;
          });
        } 
        else {
          this.promisePending = true;
          let inputNoteData = {
            note: this.note.body,
            internal: this.isNoteInternal,
            noteCaseId: this.$route.params.id,
            noteUserId: this.$Session.userId
          };

          this.getAtMentionUsers (inputNoteData);

          //add data for atMentions key
          if (this.atMentionsUserList && this.atMentionsUserList.length) {
            let atMentionsList = {
              items: this.atMentionsUserList
            };
            inputNoteData.atMentions = JSON.stringify(atMentionsList);
          }
      
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          inputNoteData['noteUpdatedById'] = this.$reduce(this, '$Session.userId');

          let gqlRequest = graphqlOperation(mutations['createNote'], {input: inputNoteData});
          this.$c.log('gqlRequest', gqlRequest);
          const result = await API.graphql(gqlRequest)
          .then(async result => {
            this.$c.log(result);
            
            this.noteId = result.data.createNote.id
            this.attachments = this.attachmentData
            await this.add(this.getNoteAttachmentRelations())
            
            this.snackbar.status = true
            this.snackbar.content = 'Note added successfully'
            this.snackbar.icon = 'done'
            this.noteId = null
            this.attachments = []
            this.placeHolder()
            this.promisePending = false;
            this.clearNoteEditor();
          })
          .catch(error => {
            this.noteId = null
            this.attachments = []
            this.promisePending = false;
            this.dialog.status = true;
            if (error.errors && error.errors[0] && error.errors[0].message) {
              this.dialog.content = error.errors[0].message;
            }
            this.$c.log(error);
            this.clearNoteEditor();
          });
        }        
      },
      getAtMentionUsers (noteData) {
        this.placeHolder();
        this.noteMentionList.forEach(el => {
          if(noteData.note.includes(el.name)) {
            if(this.atMentionsUserList.indexOf(el.id) == -1) {
              this.atMentionsUserList.push(el.id);
            }
          }
        });
      },
      /**
       * placeholder() extracts attributes from comment body html,
       * searches @mention user's name and push it into userMentionArray
       */
      placeHolder () {
        let userMentionArray = [];
        //match attributes in html string
        let attributes = this.note.body.match(/[\w-]+="[^"]*"/g);

        if(attributes !== null) {
          attributes.forEach(el => {
            if(el.startsWith('id=')) {
              let replace1 = el.replace('id="', "");
              let replace2 = replace1.replace('"', '');
              //add extracted user name from attributes array in userMentionArray
              userMentionArray.push(replace2);
            }
          });
        }

        //if userMentionArray have data then form noteMentionList
        if(userMentionArray){
          userMentionArray.forEach(ele => {
            let obj = this.userListItems.find(o => o.name === ele);
            if (obj) {
              this.noteMentionList.push(obj);
            }
          });
        }
      },
      onReply (mode, replyItem, blockChangeTab, skipScroll) {
        console.log("onReply");
        this.blockChangeTab = (blockChangeTab !== true) ? true : false;
        this.replyItem = (this.blockChangeTab) ? JSON.parse(JSON.stringify(replyItem)) : this.replyItem ? JSON.parse(JSON.stringify(this.replyItem)) : replyItem;
        this.files = [];
        this.chunkFiles = [];
        this.showEditorFlag = true;
        let replyItemcaseID = '', fromEmails = [], fromEmail = replyItem.from;
        if(replyItem.messageCaseId)
          replyItemcaseID = replyItem.messageCaseId.split('-');          
        if(replyItem.from) {
          replyItem.from.replace(/\<(.*?)\>/g, function(_, match){
            fromEmails.push(match);
          });
          if(fromEmails.length)
            fromEmail = fromEmail[0];
        }
        
        let messageItem = JSON.parse(JSON.stringify(this.replyItem));
        let thread = JSON.parse(JSON.stringify(this.replyItem))
        this.buildThreadTree(thread, this.recordData.messages.items);
        let threadEmailContent = '';
        if(thread){
           threadEmailContent = this.buildThreadReplyHtml(thread, `<br /><div id="separator-${messageItem.id}">`) + '</div>';
        }        
        switch(mode){
          case 'retry':
          case 'reply':
          case 'replyAll':
            this.reply = {};
            this.$set(this, 'reply', messageItem);
            if (this.reply.user) {
              this.reply.to = this.reply.user.email;
            } else if (this.reply.person) {
              this.reply.to = this.reply.person.email;
            }
            // ATLAS-382 : System should use the persons email (When assigning person to case) for the Reply and forward functionality
            else if (this.recordData.person && this.recordData.person.email) {
              this.$set(this.reply, 'to', this.recordData.person.email);
            }
            
            /**
             * Messaging - Display Outgoing Messages that have failed
             * Get bounced info and set to field value to emails of bounced recipients
             * @see https://zeamster.atlassian.net/browse/ATLAS-558
             */
            if ('retry' == mode) {
              try {
                replyItem.bounces = JSON.parse(replyItem.bounces);
              } catch (e) {
                replyItem.bounces = null;
              }
              const bouncedRecipients = this.$reduce(replyItem, 'bounces.bounce.bouncedRecipients');
              if (bouncedRecipients && bouncedRecipients.length) {
                const emails = [];
                bouncedRecipients.forEach(_recepient => emails.push(_recepient.emailAddress));
                this.$set(this.reply, 'to', emails.join(','));
              }
            }
            
            if (mode == 'reply' || 'retry' == mode)
            {
              this.$set(this.reply, 'cc', '');
              this.$set(this.reply, 'bcc', '');
            }
            this.$set(this.reply, 'body', '');
            if (!this.reply.subject || !this.reply.subject.length) {
              this.$set(this.reply, 'subject', '');
            }
            if (!this.reply.subject.includes('[#') && replyItemcaseID != '') {
              this.$set(this.reply, 'subject', "RE: [#" + replyItemcaseID[0] + "] " + this.reply.subject);
              this.$set(this.reply, 'body', "<br/>" + this.reply.body);
              this.$set(this.reply, 'body', this.reply.body + threadEmailContent);
            } else {
              if(this.reply.subject){
                this.$set(this.reply, 'body', "<br/>" + this.reply.body + threadEmailContent);
                let checkRE = this.reply.subject.substring(0,3);
                if (checkRE != 'RE:')
                  this.$set(this.reply, 'subject', "RE: " + this.reply.subject);
              }else{
                this.$set(this.reply, 'subject', "RE: " + this.form.subject);
                let thread = {
                  createdAt : this.recordData.createdAt,
                  subject : this.reply.subject,
                  body : this.form.subject
                }                            
                const threadEmailContent = this.buildThreadReplyHtml(thread, `<br /><div id="separator-${messageItem.id}">`) + '</div>';
                this.$set(this.reply, 'body', "<br/>" + this.reply.body + threadEmailContent);
              }
            }

            // this.reply.body = this.reply.body + threadEmailContent ;
            window.$bus.$emit('refreshTinyMceEditor', { id: 'reply', content: this.reply.body });
            this.activeEditorTab = 'tab-reply';
            if (!skipScroll) {
              setTimeout(() => { this.scrollToHash('tab-reply'); }, 300);
            }
            break;
          case 'forward':
            this.$set(this, 'forward', messageItem);
            this.$set(this.forward, 'to', '');
            this.$set(this.forward, 'cc', '');
            this.$set(this.forward, 'bcc', '');
            this.$set(this.forward, 'body', '');
            if (!this.forward.subject) {
              this.$set(this.forward, 'subject', '');
            }
            if (this.forward.subject && !this.forward.subject.includes('[#') && replyItemcaseID != '') {
              this.$set(this.forward, 'subject', "FW: [#" + replyItemcaseID[0] + "] " + this.forward.subject);
              this.$set(this.forward, 'body', "<br/>" + this.forward.body);
              this.$set(this.forward, 'body', this.forward.body + threadEmailContent);
            } else {
              if(this.forward.subject){
                this.$set(this.forward, 'body', this.forward.body + threadEmailContent); 
                let checkFW = this.forward.subject.substring(0,3);
                if (checkFW != 'FW:')
                  this.$set(this.forward, 'subject', "FW: " + this.forward.subject);
              }else{
                this.$set(this.forward, 'subject', "FW: " + this.form.subject);              
                let thread = {
                  createdAt : this.recordData.createdAt,
                  subject : this.forward.subject,
                  body : this.form.subject
                }                              
                const threadEmailContent = this.buildThreadReplyHtml(thread, `<br /><div id="separator-${messageItem.id}">`) + '</div>';
                this.$set(this.forward, 'body', this.forward.body + threadEmailContent);                  
              }
            }

            // this.forward.body = this.forward.body + threadEmailContent ;
            window.$bus.$emit('refreshTinyMceEditor', { id: 'forward', content: this.forward.body });
            this.activeEditorTab = 'tab-forward';
            if (!skipScroll) {
              setTimeout(() => { this.scrollToHash('tab-forward'); }, 300);
            }
            break;
          default:
            break;
        }
      },

      buildThreadTree(thread, items) {
        const reply = items.find(_item => _item.id == thread.replyToMessageId);
        if (reply && reply.id) {
          thread.reply = JSON.parse(JSON.stringify(reply));
          this.buildThreadTree(thread.reply, items);
        }
      },

      buildThreadReplyHtml(thread, html) {
        html = `
          ${html}
          <ul style="margin: 15px; padding-left: 15px; border-left: 1px solid #152a4c;">
            <li id="${thread.id}" style="list-style-type: none;">
              Date: ${thread.createdAt}<br />              
              ${thread.from ? `From: ${thread.from}<br />` : ''}
              ${thread.to ? `To: ${thread.to}<br />` : ''}   
              ${thread.cc ? `CC: ${thread.cc}<br />` : ''}
              ${thread.bcc ? `BCC: ${thread.bcc}<br />` : ''}
              Subject: ${thread.subject}<br />
              ${thread.body}
        `;
        if (thread.reply) {
          html = this.buildThreadReplyHtml(thread.reply, html);
        }
        html += '</li></ul>';
        return html;
      },
      async onShowAttachment (message, showAttachmentStatus) {
        let attachmentId = message.messageAttachmentId;
        let messageId = message.id;
        let indexToUpdate = _.findIndex(this.recordData.messages.items, {
          id: messageId
        });
        this.recordData.messages.items[indexToUpdate]['showAttachmentStatus'] = showAttachmentStatus;
        if(this.attachmentFetchedMessagesId.indexOf(messageId) == -1)
        {
          this.attachmentFetchedMessagesId.push(messageId);
          this.fetchAttachmentPromisePending = true;

          // message attachments query
          let operation = graphqlOperation(queries_custom.searchCaseAttachments, {
            filter: {
              esQuery: JSON.stringify({
                bool: {
                  must: [
                    { match_phrase: { relationMessageId: messageId } },
                    { match_phrase: { fromModelType: 'Message' } },
                    { match_phrase: { toModelType: 'Attachment' } },
                  ]
                }
              })
            },
            limit: 999,
          })

          // call graphql and search for attachments
          API.graphql(operation)
            .then(async response => {
              const attachmentItems = this.$reduce(response, 'data.searchRelations.items')
              const attachments = []
              
              // scan all valid attachments
              for (const _attachment of attachmentItems) {
                // if attachment data is not present then bail
                if (!_attachment || !_attachment.attachment || !_attachment.attachment.id) {
                  continue
                }

                // get attachment data
                const attachmentObj = _attachment.attachment

                // check attachment permission
                attachmentObj.hasPermission = true
                if (attachmentObj.internal && !this.$Session.isInternalGroupMember) {
                  attachmentObj.hasPermission = false
                }

                // get token based short time public url
                if (attachmentObj.hasPermission && attachmentObj.s3Path) {
                  attachmentObj.link = await Storage.get(attachmentObj.s3Path)
                }

                // add attachment
                attachmentObj.fileName = attachmentObj.name
                attachments.push(attachmentObj)
              }

              // force data refresh
              this.recordData.messages.items[indexToUpdate]['attachments'] = attachments
              this.updateFormAfter({ getCase: this.recordData })
              this.fetchAttachmentPromisePending = false;
            })
            .catch(err => {
              this.updateFormAfter({ getCase: this.recordData })
              this.fetchAttachmentPromisePending = false
            })
        } else {
          this.updateFormAfter({'getCase': this.recordData});
        } 
      },
      loadDraftMessage (mode, draftItem, skipScroll) {
        this.files = [];
        this.chunkFiles = [];
        this.showEditorFlag = true;
        switch(mode){
          case 'reply':
          case 'replyAll':
            this.reply = {};
            this.reply = JSON.parse(JSON.stringify(draftItem));
            window.$bus.$emit('refreshTinyMceEditor', { id: 'reply', content: this.reply.body });
            this.activeEditorTab = 'tab-reply';
            if (!skipScroll) {
              setTimeout(() => { this.scrollToHash('tab-reply'); }, 300);
            }
            break;
          case 'forward':
            this.forward = {};
            this.forward = JSON.parse(JSON.stringify(draftItem));
            window.$bus.$emit('refreshTinyMceEditor', { id: 'forward', content: this.forward.body });
            this.activeEditorTab = 'tab-forward';
            if (!skipScroll) {
              setTimeout(() => { this.scrollToHash('tab-forward'); }, 300);
            }
            break;
          default:
            break;
        }
      },
      onNoteEdit (noteItem) {
        this.noteItem = noteItem;
        this.note.body = noteItem.note;
        this.isNoteInternal = noteItem.internal;
        this.showEditorFlag = true;
        
        // if attachments were updated then they will be in attachmentData - 
        // then we will show updated attachments in dialog
        if (!this.attachmentData || !this.attachmentData.length) {
          // if attachments were not updated then show attachments in note
          if (noteItem.attachment && noteItem.attachment.length) {
            this.attachmentData = noteItem.attachment
          }
        }
        
        this.activeEditorTab = 'tab-note';
        this.scrollToHash('tab-note');
      },
      clearNoteEditor () { 
        this.noteItem = null;
        this.note.body = '';
        this.note.internal = false;
        this.isNoteInternal = false;
        window.$bus.$emit('refreshTinyMceEditor', { id: 'note', content: '' });            
        this.showEditorFlag = false;
        //clean the array
        this.atMentionsUserList.splice(0, this.atMentionsUserList.length);
        this.attachmentData = null;
      },
      clearEditor (editor) {
        this[editor].body = '';
        window.$bus.$emit('refreshTinyMceEditor', { id: editor, content: '' });            
        this.showEditorFlag = false;
      },
      noteItemSelected (item) {
        console.table(item);

      },
      autoSaveCaseDraft (editor) {

        let data = {
          caseDraftCaseId:this.recordData.id,
          caseDraftUserId: this.$Session.userId,
          internal: false,
          draftType : editor,
          subject: this[editor].subject,
          from: this[editor].from ? this[editor].from : ' ',
          messageCaseId: this[editor].messageCaseId ? this[editor].messageCaseId : this.$route.params.id,
        };
        data.to = this[editor].to ? this[editor].to : " ";
        // added cc if reply, replyAll and foward action add email id in cc
        data.cc = this[editor].cc ? this[editor].cc : " ";
        // added bcc if reply, replyAll and foward action add email id in bcc
        data.bcc = this[editor].bcc ? this[editor].bcc :" ";  
        
        data.body = this[editor].body ? this[editor].body :"";  

        data.replyToMessageId = this[editor].id ? this[editor].id : ' ';

        let record = this.draftOwnerFilter(editor);
        if (record.length) {
          data.id = record[0].id;
          if (data.subject && data.body)
            this.updateMessageDraft(data);
        } else {
          if (data.subject &&  data.body)
          {
            this.saveCaseDraft(data);
          }
        }
        
      },
      async saveCaseDraft (data) {
        if(this.draftPromisePending == false) {
          this.draftPromisePending = true;
          this.draftSavedStatus = true;
          this.saveDraft = false;
          let gqlRequest = graphqlOperation(mutations['createCaseDraft'], {input: data});
          this.$c.log('gqlRequest', gqlRequest);

          const result = await API.graphql(gqlRequest)
          .then(result => {
            this.$c.log('createCaseDraft ',result);
            this.recordData.caseDrafts.items.push(result.data.createCaseDraft);
            this.updateDraft = true;
            this.draftPromisePending = false; 
            this.draftSavedStatus = false;
          })
          .catch(error => {
            this.draftPromisePending = false;
            this.draftSavedStatus = false;
            this.$c.log(error);
            this.dialog.status = true;
            this.dialog.content = error.errors[0].message;
          });
        }
      },
      async updateMessageDraft (data) {
        if(this.draftDeletePromisePending == false) {
          this.draftSavedStatus = true;
          let gqlRequest = graphqlOperation(mutations['updateCaseDraft'], {input: data});
          this.$c.log('gqlRequest', gqlRequest);

          const result = await API.graphql(gqlRequest)
          .then(result => {
            this.$c.log('updateMessageDraft ',result);
            this.draftSavedStatus = false;
          })
          .catch(error => {
            this.$c.log(error);
            this.dialog.status = true;
            let msg = '';
            if (error && error.errors && error.errors.length) {
              msg = error.errors[0].message;
            }
            this.dialog.content = msg;
          });
        }        
      },
      cancelDraft (editor) {
        if(this.draftPromisePending === false){
          this.draftDeletePromisePending = true;
          let deleteDraftItem = this.draftOwnerFilter(editor);
          if(this.draftOwnerFilter(editor).length){
            API.graphql(graphqlOperation(mutations["deleteCaseDraft"], {
              input: { id: deleteDraftItem[0].id }
            }))
            .then(result => {
              this.saveDraft = true;
              this.updateDraft = false;
              this.reply.Item = null;
              let removeIndex = this.recordData.caseDrafts.items.findIndex(item => item.id === result.data.deleteCaseDraft.id);
              this.recordData.caseDrafts.items.splice(removeIndex,1);
              this.draftDeletePromisePending = false;
            })
            .catch(error => {
              this.draftDeletePromisePending = false;
              this.$c.log("delete record error:",error);
              this.dialog.status = true;
              this.dialog.content = error.errors[0].message;
            });
          } else {
            this.reply.Item = null;
          }
        }
      },
      onGroupChange(groupIndex) {
        this.groupIndex = groupIndex;
      },
      onOrderChange(orderIndex) {
        this.orderIndex = orderIndex;
      },
      onDialogChange(newValue) {
        this.tasksList.showRelatedDialog = newValue;
      },
      openCaseMergeDialog(){
        this.mergeCaseList.showRelatedDialog = true;
      },
      async updateFormAfter(data) {
        if (typeof data === 'undefined') return;
        this.updateFormData = data;
        let items = await this.mergeMessagesAndNotes(data);
        this.sortMessagesAndNotes(items);
        this.messagesAndNotes = items;
        this.loadDeepLinkMessageOrNote();
        this.loadTeamList(data);
        this.loadUserList(data);
        this.loadPersonList(data);

        this.loadRelatedRecords(data, 'companies', 'company');
        this.loadRelatedRecords(data, 'accounts', 'account');
        this.loadRelatedRecords(data, 'services', 'service');
        this.loadRelatedRecords(data, 'products', 'product');
        this.loadRelatedRecords(data, 'salesreps', 'salesrep');

        let totalCount = this.form.companies.length + this.form.accounts.length + this.form.services.length + this.form.products.length + this.form.salesreps.length
        window.$bus.$emit("badge-changed", 'targets', totalCount)

        this.loadEnumFields(data);

        this.loadCaseTemplateList(data);

        // make sure we don't show alert message repeatedly
        if (this.shouldShowAlertMessage) {
          this.shouldShowAlertMessage = false
          this.showAlertMessageNotification()
        }

        /**
         * ATLAS-961: <Case> <Task> When reassigning a case to a new assignee,
         * a popup box will ask if the user wants to assign all task,
         * or keep certain task by deselecting the check box
         */
        if(data && data.getCase){
          let caseData = data.getCase;
          this.caseAssignee.reassignTasks = [];

          if(caseData.user && caseData.user.id && caseData.user.given_name) {
            this.caseAssignee.assigneeId = caseData.user.id;
            this.caseAssignee.assignee = caseData.user.given_name + ' ' + caseData.user.family_name;
          }
          
          if(caseData.tasks && caseData.tasks.items && caseData.tasks.items.length) {
            caseData.tasks.items.forEach(item => {
              //if task status not in Completed / Closed_By_Workflow
              if (item.status != "Completed" && item.status != "Closed_By_Workflow" && item.status != "Closed") {
                let tempItem = {};
                tempItem['id'] = item.id;
                tempItem['subject'] = item.subject;
                tempItem['status'] = item.status;
                tempItem['dateDue'] = moment(String(item.dateDue)).format('MMM DD, YYYY');
                tempItem['assignee'] = item.user ? (item.user.given_name + ' ' + item.user.family_name) : "";
                this.caseAssignee.reassignTasks.push(tempItem);
              }
            });
            console.log("caseAssignee.reassignTasks: ", this.caseAssignee.reassignTasks);
          }
        }

        /**
         * get messages, notes data for Case Merge Function
         */
        if(data && data.getCase){
          let caseData = data.getCase;
          if((caseData.tasks && caseData.tasks.items && caseData.tasks.items.length === 0)
          && ((caseData.messages && caseData.messages.items && caseData.messages.items.length > 0)
          || (caseData.notes && caseData.notes.items && caseData.notes.items.length > 0))) {
            this.formConfig.showMergeCaseOption = true;
            this.mergeCaseList.sourceCaseSubject = caseData.subject;
          }
          if(caseData.messages && caseData.messages.items && caseData.messages.items.length > 0) {
            const caseMessageList = [];
            caseData.messages.items.forEach((_el, index) => {
              let element = {};
              element.id = _el.id;
              element.subject = _el.subject;
              caseMessageList.push(element);
            });
            this.mergeCaseList.sourceCaseMessagesList = caseMessageList;
          }
          if(caseData.notes && caseData.notes.items && caseData.notes.items.length > 0) {
            const caseNotesList = [];
            caseData.notes.items.forEach((_el, index) => {
              let element = {};
              element.id = _el.id;
              element.note = _el.note;
              caseNotesList.push(element);
            });
            this.mergeCaseList.sourceCaseNotesList = caseNotesList;
          }
        }

      },
      loadEnumFields(data) {
        // Populate all of the enumFields
        let enumFields = {
          'origin': 'listCaseOriginEnum',
          'status': 'listCaseStatusEnum',
          'priority': 'listCasePriorityEnum',
          'type': 'listCaseTypeEnum',
        }
        this.$loopo(enumFields, (source, field) => {
          // Update the options for each field
          (($this) => {
            let options = [];
            if (data[source] && data[source].enumValues) {
              this.$loopo(data[source].enumValues, (value) => {
                options.push({name: value.name.replace(/_/g, ' '), id: value.name});
              });
            }
            $this.options = options;

            // EDIT MODE - Select the current option if one exists.
            if (this.recordData && this.recordData[field]) {
              this.$v.form[field].$model = this.recordData[field];
            }
          })(this.formConfig.fields[field]);
        });
      },

      loadRelatedRecords(data, name, target) {
        console.log("loadRecords data",data);
        console.log("loadRecords name",name);
        console.log("loadRecords target",target);
        let result = [];
        if (data && data.getCase && data.getCase[name] && data.getCase[name].items && data.getCase[name].items.length) {
          let items = data.getCase[name].items;
          items.forEach(item => {
            item[target].relateRecordId = item.id;
            result.push(item[target]);
          });
        }
        this.form[name] = result;
      },


      loadCaseTemplateList(data) {
        /**
         * ATLAS-619 Case CRUD: Selected Case template is not showing in view/edit mode
         */
        if(data && data.getCase && data.getCase.template && data.getCase.template.id) {
          this.form.caseTemplateId = data.getCase.template.id;
        }

        const items = this.$reduce(data, 'listCaseTemplates.items');
        let options = [];
        if (items && items.length) {
          items.map(_item => {
            const item = JSON.parse(JSON.stringify(_item));
            item.name = _item.subject;
            if(_item.hasWorkflow){
              this.workflowCaseTempList.push(item)
              console.log('skip this template as it is of workflow ',item)
            }else{
              options.push(item);
            }            
          });
          this.$set(this.formConfig.fields.caseTemplateId, 'options', options);
        }
      },

      loadUserList(data) {
        (($this) => {
          $this.data = [];
          // if (data && data.listUsers && data.listUsers.items) {
          //   $this.data = data.listUsers.items;
          // }
          if (this.recordData && this.recordData.user) {
            $this.searchTerm = this.recordData.user.given_name + ' ' + this.recordData.user.family_name;
            this.form.caseUserId = this.recordData.user.id;
          } else {
            if (this.$route.query.caseUserId) {
              this.$v.form.caseUserId.$model = this.$route.query.caseUserId;
              /** try to find the User name */
              let matchingIndex = $this.data.findIndex(
                item => item.id === this.form.taskUserId
              );
              if (matchingIndex >= 0) {
                $this.searchTerm = $this.data[matchingIndex].given_name;
              }
            }
            if (this.$Session.userId && this.formConfig.pageMode === 'new') {
              let currentUser = this.$Session.user.attributes;
              $this.searchTerm = currentUser.given_name + ' ' + currentUser.family_name;
              this.form.caseUserId = this.$Session.userId;
            }
          }
        })(this.formConfig.fields.caseUserId);
      },
      loadTeamList(data) {
          //Update the listTeams auto-complete
        (($this) => {
          $this.data = [];
          // if (data && data.listTeams && data.listTeams.items) {
          //   $this.data = data.listTeams.items;
          // }
          if (this.recordData && this.recordData.team) {
            $this.searchTerm = this.recordData.team.name;
            this.form.caseTeamId = this.recordData.team.id;
          } else {
            if (this.$route.query.caseTeamId) {
              this.$v.form.caseTeamId.$model = this.$route.query.caseTeamId;
              /** try to find the company name */
              let matchingIndex = $this.data.findIndex(
                item => item.id === this.form.caseTeamId
              );
              if (matchingIndex >= 0) {
                $this.searchTerm = $this.data[matchingIndex].name;
              }
            }
          }
        })(this.formConfig.fields.caseTeamId);
      },
      loadPersonList(data) {
          //Update the listPerson auto-complete
        (($this) => {
          $this.data = [];
          // if (data.listPersons && data.listPersons.items && data.listPersons.items.length) {
          //   $this.data = data.listPersons.items;
          // }
          if (this.recordData && this.recordData.person) {
            $this.searchTerm = this.recordData.person.given_name + ' ' + this.recordData.person.family_name;
            this.form.casePersonId = this.recordData.person.id;
          } else {
            if (this.$route.query.casePersonId) {
              this.$v.form.casePersonId.$model = this.$route.query.casePersonId;
              /** try to find the User name */
              let matchingIndex = $this.data.findIndex(
                item => item.id === this.form.casePersonId
              );
              if (matchingIndex >= 0) {
                $this.searchTerm = $this.data[matchingIndex].given_name;
              }
            }
          }
        })(this.formConfig.fields.casePersonId);
      },
      async getChangeDetails () {
        let operation = [];
        let params = {};
        params.filter = {"and": [{"modelName": {"eq": "Case"}}, {"modelId": {"eq": this.$route.params.id}}]};
        params.limit = 999;
        operation = graphqlOperation(queries['searchChanges'],params);
        const result = await API.graphql(operation);
        console.log('getchangeListItems', result.data);
        this.changeListItems = result.data;
      },
      async mergeMessagesAndNotes(data) {
        const items = [];
        if (data.getCase && data.getCase.messages && data.getCase.messages.items) {
          data.getCase.messages.items.map(_message => {
            const message = JSON.parse(JSON.stringify(_message));
            message._type = 'message';
            items.push(message);
          });
        }
        if (data.getCase && data.getCase.notes && data.getCase.notes.items) {
          for (const _note of data.getCase.notes.items) {
            let attachment = await this.getAttachment(_note.id, "note");
            const note = JSON.parse(JSON.stringify(_note));
            note.attachment = attachment;
            note._type = 'note';
            items.push(note);
          }
        }
        if (data.getCase && data.getCase.tasks && data.getCase.tasks.items) {
          for (const _task of data.getCase.tasks.items) {
            for (const _comment of _task.comments.items) {
              let attachment = await this.getAttachment(_comment.id, "comment");
              const comment = JSON.parse(JSON.stringify(_comment));
              comment.attachment = attachment;
              comment._type = 'taskComment';
              comment.task_id = _task.id;
              comment.task_subject = _task.subject;
              if (typeof comment.parentComment === 'undefined') {
                items.push(comment);
              }else if (comment.parentComment === null) {
                items.push(comment);
              }
            }
          }
        }
        if (this.changeListItems && this.changeListItems.searchChanges && this.changeListItems.searchChanges.items) {
          let filterChange = ['caseUserId','status', 'taskId', 'subject']
          
          this.$loopo(this.changeListItems.searchChanges.items, (_changeItems, key) => {
            const change = JSON.parse(JSON.stringify(_changeItems));
            let updateChangeItem = {};
            try {
              updateChangeItem = JSON.parse(change.change);
              if ('object' !== typeof updateChangeItem) {
                try {
                  // for items received via subscriptions - the change is a slash
                  // escaped string - try and decode the string
                  // remove double quotes from start and end / remove backslashes
                  let changeJsonStr = change.change
                    .replace(/^"/, '')
                    .replace(/"$/, '')
                    .replace(/\\/ig, '')
                  updateChangeItem = JSON.parse(changeJsonStr);
                } catch (e) {
                  updateChangeItem = {};
                }
              }
            } catch (e) {
              updateChangeItem = {};
            }
            let changeKey = Object.keys(updateChangeItem);
            if((change.action == "modify") || (change.action == "insert") || (change.action == "remove")) {
              
              const compareChanges = filterChange.filter(element => changeKey.includes(element));
              if(compareChanges.length >= 1) {
                let activity = this.arrangeChange(updateChangeItem, change.action);
                if(activity && activity.length && 'object' == typeof activity) {
                  activity.forEach(_activity => {
                    const newChange = _.cloneDeep(change);
                    newChange._type = 'change';
                    newChange._activity = _activity;
                    items.push(newChange);
                  });
                }                       
              }
            } 
          });
        }
        return items;
      },

      /**
      * Get attachment Types Enum
      * @returns {Array} array of objects holding enum options
      */
      async getAttachment(noteId, type) {
          var filterData = type == "note" ? { relationNoteId: { eq: noteId } } : { relationCommentId: { eq: noteId } }
          return new Promise((resolve, reject) => {
          let operation = graphqlOperation(queries_custom.searchCaseAttachments, { filter: filterData, limit: 999 });
          API.graphql(operation)
          .then(response => {
          let values = this.$reduce(response, 'data.searchRelations.items');
          let options = [];
          const amplifyEnv = aws_exports.aws_content_delivery_bucket.match(/.*-(\w+)/)[1]
          const s3Bucket = 'atlasemailattachments-' + amplifyEnv 
          for (const _value of values) {
            if (!_value.attachment) {
              continue
            }
            if (_value.attachment.isDeleted === null || _value.attachment.isDeleted === undefined || _value.attachment.isDeleted === false) {
              let url = `https://${s3Bucket}.s3.amazonaws.com/${_value.attachment.s3Path}`;
              options.push({
                id: _value.attachment.id,
                description: _value.attachment.description,
                name: _value.attachment.name,
                s3Path: url,
                type: _value.attachment.type.replace(/_/ig, ' '),
                internal: _value.attachment.internal
              });
            }
          }
          resolve(options.length > 0 ? options : null);
          })
          .catch(err => {
          console.log('getAttachment - Error', err);
          resolve(null);
          });
          });
      },

      arrangeChange (changeItem, action) {
        if(typeof changeItem.taskId != "undefined")
          var taskName = changeItem.taskSubject ? changeItem.taskSubject : changeItem.taskId;
          var taskNameLink = "<a href=\"#/tasks/" + changeItem.taskId + "\" target=\"_self\">" + taskName + "</a>"
        let activity = [];
        if(action == "modify") {
          if(typeof changeItem.status != "undefined") {
            activity.push(" Changed the case status to - " + changeItem.status.replace(/_/g, " ")); 
          }
          if(typeof changeItem.caseUserId != "undefined") {
            activity.push(" Assigned the case to user " + changeItem.caseUserId);
          }
          if(typeof changeItem.taskId != "undefined") {
            if(typeof changeItem.updatedTask != "undefined") {
              if(typeof changeItem.updatedTask.taskUserId != "undefined"){
                activity.push(" Assign the user - " + changeItem.updatedTask.taskUserId + " to task - " + taskNameLink);
              } else if (typeof changeItem.updatedTask.status != "undefined") {
                activity.push(" Changed the task - " + taskNameLink + " status to " + changeItem.updatedTask.status);
              } else if (typeof changeItem.updatedTask.taskCaseId != "undefined") {
                activity.push(" Assigned the task - " + taskNameLink);
              }
            } else {
              activity.push(" Assigned the task - " + taskNameLink);
            }
          }
        }
        if(action == "insert") {
          if(typeof changeItem.taskId != "undefined"){
            if(typeof changeItem.updatedTask == "undefined") {
              activity.push(" Created a new task - " + taskNameLink);
            }
          } else if (typeof changeItem.subject != "undefined") {
            if (typeof changeItem.status != "undefined") {
              activity.push(" Change the status - " + changeItem.status.replace(/_/g, " "));
            }
            if(typeof changeItem.caseUserId != "undefined"){
              activity.push(" Assigned the case to user - " + changeItem.caseUserId);
            }
            activity.push(" Created a new Case - " + changeItem.subject);
          }
        } 
        if(action == "remove") {
          if(typeof changeItem.taskId != "undefined"){
            if(typeof changeItem.updatedTask == "undefined") {
              activity.push(" Deleted a task - " + taskName);
            }
          }
        }
        return activity;
      },
      sortMessagesAndNotes(items) {
        items.sort((prev, next) => {
          const prevDate = new Date(prev.updatedAt).getTime();
          const nextDate = new Date(next.updatedAt).getTime();
          if (prevDate < nextDate) {
            return 1;
          }
          if (prevDate > nextDate) {
            return -1;
          }
          return 0;
        });

        return items;
      },
      loadDeepLinkMessageOrNote() {
        const hashId = this.$route.hash.replace('#', '');
        const index = this.messagesAndNotes.findIndex((_item) => hashId == _item.id);
        if (-1 === index) {
          return;
        }
        this.isDeepLinkLoadInProgress = true;
        this.messagesAndNotesPage = Math.ceil((index + 1) / this.messagesAndNotesItemsPerPage);
      },
      loadNextMessagesAndNotes() {
        this.messagesAndNotesPage++;
      },
      onMessagesAndNotesFilterChange(items) {
        if (!this.isDeepLinkLoadInProgress) {
          this.messagesAndNotesPage = 1;
        }
        this.isDeepLinkLoadInProgress = false;
        this.messagesAndNotesFiltered = items;

        let message = items.find(_item => 'message' == _item._type);
        if (!message || !message.id) {
          message = {};
        }
        this.defaultItem = message;
      },
      generateMessagesFilter() {
        if (this.$Session.isInternalGroupMember) {
          this.formConfig.messagesFilter = undefined;
          return;
        }
        this.formConfig.messagesFilter = { internal: { eq: false } };
      },
      getAttachmentIndex(chunkIndex, fileIndex) {
        const index = chunkIndex * 6 + fileIndex;
        if (!this.attachmentOptions || !this.attachmentOptions[index]) {
          this.attachmentOptions[index] = { internal: false };
        }
        return index;
      },
      getAttachmentOptions() {
        this.chunkFiles.forEach((_chunk, _chunkIndex) => {
          _chunk.forEach((_file, _fileIndex) => {
            const index = this.getAttachmentIndex(_chunkIndex, _fileIndex);
            this.attachmentOptions[index].name = _file.name;
            this.attachmentOptions[index].size = _file.size;
          }); 
        });
        return this.attachmentOptions;
      },
      handleTaskStepNotification(eventData) {
        const step = this.$reduce(eventData, 'value.data.onUpdateTaskStep');
        const caseId = this.$reduce(step, 'task.case.id');
        if (caseId && caseId == this.$route.params.id) {
          
          const task = step.task;
          
          // find task in existing tasks list
          let taskItems = this.$reduce(this, 'recordData.tasks.items');
          const existingTaskIndex = taskItems.findIndex(_item => _item.id == task.id);
          if (-1 == existingTaskIndex) {
            return;
          }
          
          const existingTask = this.recordData.tasks.items[existingTaskIndex];
          
          // check and set existing task step items if it does not exist
          let stepItems = this.$reduce(existingTask, 'steps.items');
          if (!stepItems || !stepItems.length) {
            this.$set(existingTask.steps, 'items', []);
          }
          
          const existingSteps = existingTask.steps.items;
          const existingStepIndex = existingSteps.findIndex(_step => _step.id == step.id);
          if (-1 == existingStepIndex) {
            existingSteps.push(step);
          } else {
            this.$set(existingSteps, existingStepIndex, step);
          }
          
          // this.refresh();
        }
      },
      // checkServicePendingResponce(response) {
      //   const serviceItems = response.services.items;
      //   if(serviceItems.length > 0) {
      //     if(serviceItems[0].service.status != "Pending") {
      //       let items = response.tasks.items;
      //       items.forEach((item, index) => {
      //         if (item.subject === "Follow up on Pending") {
      //           delete response.tasks.items[index];
      //         }
      //       });
      //     } else {
      //       return response.tasks;
      //     }
      //   }
      //   return response.tasks;
      // }

      /**
       * Show attachment upload form
       * @returns {Void}
       */
      onOpenAttachmentDialog() {
        this.isUploadDialogOpen = true;
      },
      /**
       * Attachment was successfully added or updated
       * Close dialog
       * @returns {Void}
       */
      onUploadSuccess(attachmentData) {
        this.isUploadDialogOpen = false;
        this.attachmentData = attachmentData;
        console.log("attachmentData ", attachmentData);
      },
      removeFile(){
        this.attachmentData = null;
      },
      /**
       * Update attachment intrnal flag
       * @returns {Promise}
       */
      async updateAttachmentInternalFlag(id) {
        let input = {
          id: id,
          internal: this.attachmentData.internal,
          attachmentUpdatedById: this.$reduce(this, '$Session.userId'),
        };
        const operation = graphqlOperation(mutations.updateAttachment, { input });
        return API.graphql(operation)
      },
      /**
       * Delete attachment
       * @returns {Promise}
       */
      async deleteAttachment(id) {
        let input = {
          id: id,
          isDeleted: true,
          attachmentUpdatedById: this.$reduce(this, '$Session.userId'),
        };
        const operation = graphqlOperation(mutations.updateAttachment, { input });
        return API.graphql(operation)
      },
      addTask() {
        this.tasksList.showRelatedDialog = true;
      },
      async onAddTaskToCaseTemplate(item) {
        console.log(item);
        this.tasksList.showRelatedDialog = false;
        if(item.user === null) {
          item.user = {
            id: this.$Session.userId,
            given_name: this.$Session.user.attributes.given_name,
            family_name: this.$Session.user.attributes.family_name,
            email: this.$Session.user.attributes.email
          };
        }
        if(item.status == null) {
          item.status = "Open";
        }
        if(item.dateDue == null) {
          item.dateDue = new Date().toUTCString();
        }
        this.addTaskAtEnd(item, true).then(response => {
          console.log("success");
          window.$bus.$emit('caseTaskView.forceUpdate');
        })
        .catch(err => {
          console.log("fail");
        });
      },
      async onTaskCreated(item) {
        console.log(item);
        this.tasksList.showRelatedDialog = false;
        await this.addTaskAtEnd(item).then(response => {
          console.log("success");
          window.$bus.$emit('caseTaskView.forceUpdate');
        })
        .catch(err => {
          console.log("fail");
        });
      },
      async addTaskAtEnd(task, isTemplate) {        
        return new Promise(async (resolve, reject) => {
          const operation = graphqlOperation(queries_custom.editCase, {
            input: { id: this.$route.params.id },
            id: this.$route.params.id,
          });
          await API.graphql(operation)
          .then(async response => {
            console.log(response);
            this.$set(this, 'tasks', response.data.getCase.tasks.items);
            this.promisePending = false;
            let lastGroup = 0;
            for (let task of this.tasks) {
              if(Number(task.group) > lastGroup)
                lastGroup = task.group;
            }
            lastGroup++;
            let taskInputData = {
              isTemplate: false,
              //isAvailable: task.isAvailable,
              isCompleteInOrder: task.isCompleteInOrder,
              type: task.type,
              dateDue: task.dateDue,
              subject: task.subject,
              internal: task.internal,
              //owner
              group: lastGroup,
              order: '0',
              //createdAt
              //updatedAt
              priority: task.priority,
              status: task.status,
              //dateCompleted
              quickNote: task.quickNote,
              isSystemCreated: false,
              hasWorkflow: false,
              //skipAlert
              taskCaseId: this.$route.params.id,
              taskUserId: this.$Session.userId,
              //taskTaskTemplateId
              taskUpdatedById: this.$Session.userId,
            }
            if(isTemplate)
              taskInputData['taskTaskTemplateId'] = task.id;
            else
              taskInputData['id'] = task.id;
              
            let taskSteps = task.steps;;
            
            let result = false;
            let createUpdateTask = isTemplate ? 'createTask' : 'updateTask';
            const operation = graphqlOperation(mutations[createUpdateTask], {
              input: taskInputData
            });
            await API.graphql(operation)
            .then(response => {
              result = response.data[createUpdateTask];
              let taskId = result.id
              if(taskSteps.items.length) {
                let stepsPromiseArr = [];
                for(let i=0; i<taskSteps.items.length; i++) {
                  let stepsInputData = {
                    title: taskSteps.items[i].title,
                    description: taskSteps.items[i].description,
                    order: taskSteps.items[i].order,
                    status: taskSteps.items[i].status,
                    taskStepTaskId: taskId,
                    isAvailable: taskSteps.items[i].isAvailable,
                  }
                  stepsInputData['taskUpdatedById'] = this.$Session.userId;
                  let gqlRequest = graphqlOperation(mutations['createTaskStep'], {input: stepsInputData});
                  this.$c.log('gqlRequest create steps', gqlRequest);
                  stepsPromiseArr.push(API.graphql(gqlRequest));
                }
                Promise.allSettled(stepsPromiseArr).then((resultStepsPromise) => {
                  this.$c.log('Case Template Tasks and Steps Inserted Successfully');
                  console.log(resultStepsPromise);
                  resolve();
                })
              } else {
                resolve();
              }
            })
            .catch(error => {
              this.$c.log(error);
              reject();
            });
          })
          .catch(error => {
            console.log(error);
            reject();
          });
        });
        
      }
    },
    watch: {
      '$Session.isInternalGroupMember': {
        immediate: true,
        handler: function() {
          this.generateMessagesFilter();
        },
      },
      '$route.params': function () {
        this.$notifyClear(this.noticationTimeStamp);
        this.noticationTimeStamp = [];
        this.shouldShowAlertMessage = true
      },
      recordData () {
        if(this.recordData.tasks.items.length > 0) {
          // this.checkServicePendingResponce(this.recordData)
          this.existingTasks = this.recordData.tasks;
        } 
        // ATLAS-599 setting background color for manual case first reply/forward
        if(this.recordData && this.recordData.owner) {
          this.manualCase = true;
        }          
        
        if(this.recordData.status === 'Closed_Completed' || this.recordData.status === 'Closed_Unresolved'){
          this.setCloseDate = false;
        }else{
          this.setCloseDate = true;
        }
      },
      'formConfig.pageMode' : {
        handler: function() {
          this.$set(this.formConfig.fields.caseTemplateId, 'preventEdit', this.form.isCompleteInOrder);
        }
      },
      'form.caseTemplateId': {
        handler: function() {
          const id = this.$reduce(this, 'form.caseTemplateId');
          const pageMode = this.$reduce(this, 'formConfig.pageMode');
          const options = this.$reduce(this, 'formConfig.fields.caseTemplateId.options');
          if (!id || !options || !options.length) {
            return;
          }
          const option = options.find(_option => _option.id === id);
          if (!option) {
            return;
          }
          if('view' != pageMode) {
            const form = this.form;
            if (!form.subject) {
              this.$set(form, 'subject', option.subject);
            }
            if (!form.internal) {
              this.$set(form, 'internal', option.internal);
            }
            if (!form.priority) {
              this.$set(form, 'priority', option.priority);
            }
            if (!form.origin) {
              this.$set(form, 'origin', option.origin);
            }
            if (!form.type) {
              this.$set(form, 'type', option.type);
            }
            if (!form.status) {
              this.$set(form, 'status', option.status);
            }
            this.$set(this.form, 'isCompleteInOrder', option.isCompleteInOrder);
            if (!form.caseTeamId) {
              const team = option.team;
              if (team && team.id) {
                (($this) => {
                  $this.searchTerm = team.name;
                  this.form.caseTeamId = team.id;
                })(this.formConfig.fields.caseTeamId);
              }
            }

            /**
             * Case Details Page:
             * Fix: Task Status is showing blank in Task view section for newly added task
             */
            option.tasks.items.forEach(item => {

              if(!item.status) {
                //set default status
                item.status = "Open";
              }
            });

            this.$set(this, 'templateTasks', option.tasks);
          }
        }
      },
      /**
       * If the current Case should be completed in order then disable 
       * delete task button
       */
      'form.isCompleteInOrder': {
        immediate: true,
        handler: function() {
          if (this.form.isCompleteInOrder) {
            this.tasksList.itemActions[1].isDisabled = true;
          }
        }
      },
      /**
       * ATLAS-704 New Application Workflow - Add fields needed to Case model
       * Clear text input if it is hidden
       */
      'form.priority': {
        immediate: true,
        handler: function() {
          if (this.form.priority !== 'Rush'){
            this.form.rushReason = '';
          }
        }
      },
      /**
       * ATLAS-961: <Case> <Task> When reassigning a case to a new assignee,
       * a popup box will ask if the user wants to assign all task,
       * or keep certain task by deselecting the check box
       */
      'form.caseUserId': {
        immediate: true,
        handler: function(newVal, oldVal) {          
          this.caseAssignee.skipAlert = (oldVal=='') ? true : false;
          //if Case assignee and selected assignee same then hide popup
          if (this.form.caseUserId && this.form.caseUserId == this.caseAssignee.assigneeId) {
            this.caseAssignee.closeDialogClicked = true;
          }

          if (this.form.caseUserId && this.form.caseUserId != this.caseAssignee.assigneeId){
            this.userListItems.forEach(item => {
              if (item.id == this.form.caseUserId) {
                this.caseAssignee.newAssigneeId = this.form.caseUserId;
                this.caseAssignee.newAssignee = item.name.replace(/_/g, ' ');
              }
            });

            //show popup only when case has existing tasks
            if(this.caseAssignee.reassignTasks && this.caseAssignee.reassignTasks.length) {
              let msg = "";
              if(this.caseAssignee.assignee) {
                msg = "Reassign Case from "+ this.caseAssignee.assignee + " to " + this.caseAssignee.newAssignee;
              } else {
                //if case assignee unavailable
                msg = "Reassign Case to " + this.caseAssignee.newAssignee;
              }
              this.caseAssignee.pageTitle = msg;
            }

            if (this.caseAssignee.skipReassignTasks === true){
              this.caseAssignee.skipReassignTasks = false;
            }

            if (this.caseAssignee.closeDialogClicked === true) {
              this.caseAssignee.closeDialogClicked = false;
            }

            //empty array once popup shows
            this.caseAssignee.selectedTasks = [];
          }
        }
      },
      /**
       * ATLAS-1007: <Case> <Link Cases> Add ability to link Cases to other Cases
       * 
       * ATLAS-1068: <Side Panel> <Linked Cases> While navigating through hyperlink,
       * the Side panel is not getting refresh, user need to manually REFRESH to see new case Side panel
       * 
       * Refresh the linkedCasesList on route change
       */
      '$route.params.id': function () {
        setTimeout(() => {
          this.$refs.linkedCasesListRef.refresh();
        }, 1000);

        setTimeout( () => {
          this.$refs.attachmentsListRefs.onSearch();
        }, 2500);
      }
    }
  }
</script>

<style scoped>
.md-bottom-bar {
    box-shadow: none;
}
.case-custom-btn .md-button:not([disabled]) {
    background-color: #E5E8E8 !important;
    border: 1px solid #D6DBDF;
}
.case-custom-btn .md-button:not(.md-just-icon) .md-button-content i {
    font-size: 1.5rem !important;
    color: #919191 !important;
}
.md-button {
    max-width: 50px;
}
.md-button[data-v-2aad7e40]:not([disabled]):hover {
    background-color: #919191 !important;
    border: 1px solid #919191;
}
.md-button:not(.md-just-icon) .md-button-content i:hover {
    color: #FFF !important;
}

/* for Linked Cases Tab */
#sidepanel-tab-links .md-card.md-theme-default {
  box-shadow: none;
}
</style>

<style lang="scss">
  /* Begin: for Linked Cases Tab */
  #sidepanel-tab-links .md-card .md-card-header.md-card-header-icon .title, .md-card .md-card-header.md-card-header-text .title {
    font-size: 14px !important;
  }
  #sidepanel-tab-links .md-field._uiKitInput.md-theme-default.md-has-placeholder {
    max-width: 35%;
  }
  #sidepanel-tab-links .md-field._uiKitInput.md-theme-default.md-has-value {
    max-width: 35%;
  }
  #sidepanel-tab-links button.md-button.md-primary.md-sm {
    min-width: 75px !important;
    margin: 0 17px 0px 0px;
  }
  #sidepanel-tab-links .paginated-table .md-table-head-label {
    font-size: 0.84rem;
  }
  #sidepanel-tab-links .md-table-cell-container {
    font-size: 0.82rem !important;
  }
  #sidepanel-tab-links p.card-category.number {
    font-size: 0.82rem;
  }
  #sidepanel-tab-links .md-card-actions.md-alignment-space-between {
    margin-left: 16px !important;
  }
  /* for refresh button overlap issue */
  .md-card.caseLinkTab.md-theme-default .md-button.md-primary.md-sm {
    margin: 0 20px 0 0;
    min-width: 14%;
  }
  .md-card.caseLinkTab.md-theme-default button#messageListRefresh {
    right: 5px !important;
  }
  /* End: for Linked Cases Tab */

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    //display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  .custom-title {
    color: #636554bd !important; 
  }

  .created-date-row {
    min-height: 2px;
  }

  .created-date {
    margin: 0px 12px auto 33px;
    color: black;
  }
  .main-panel{
    background-color: #ffffff;
  }
  .mdTabs {
    width: 100%;
    padding-top: 35px;
    margin-bottom: 35px;
    border: 1px solid #c5c5c5;
    .md-tabs {
      .md-tabs-navigation {
        display: block;
        padding: 0;
        border-bottom: 1px solid #c5c5c5;
        box-shadow: none;
        .md-button {
          .md-tabs.md-theme-default .md-tabs-indicator {
            background-color: #2196f3 !important;
          }
        }
      }
      .md-tabs-indicator {
        display: block;
      }
      .md-tab {
        padding: 0.5rem;
      }
    }
  }
  ._embeddedLabel {
    margin: 0;
    &+& {
      margin-top: -10px;
    }
    i {
      justify-content: flex-start;
      padding-top: 5px;
      font-family: inherit;
      font-size: 13px !important;
      font-weight: 500 !important;
      text-align: left;
    }
  }
  ._embeddedControls {
    z-index: 1;
    position: absolute;
    top: 45px;
    left: 20px;
    right: 20px;
    background: #fff;

    &._isReplyTab,
    &._isForwardTab {
      // top: 100px;
    }
  }


 ._embeddedControlsAdmin {
    z-index: 1;
    position: absolute;
    top: 97px;
    left: 9px;
    right: 24px;
    background: #fff;
    padding-left: 15px;

    &._isReplyTab,
    &._isForwardTab {
      // top: 100px;
    }
  }

  ._relative {
    position: relative;
  }

  .customTaskDialogTabs.md-tabs .md-tabs-navigation {
    display: flex;
  }
  .md-dialog {
    width: 100%;
  }

  .customTaskDialogTabs.md-tabs .md-tabs-navigation .md-tab-nav-button.md-button :hover {
    transition: all .4s ease;
    -webkit-transition: all .4s ease;
    background-color: #ddd;
  }

  .md-menu-content-bottom-start.md-menu-content-small {
    z-index: 9999 !important;
  }

  #tab-message {
    min-height: 200px;

    ._filter {
      position: relative;
      float: right;
      top: 0;
      right: 0;
      width: auto;
      margin-bottom: 15px;

      ._filter__btn {
        margin-right: 0;
      }
      
      ._filter__list {
        right: 0;
        width: 200px;
      }
    }
  }

  .incoming {
    background-color: rgba(255, 255, 255, 0.38) !important;
  }

  .outgoing {
    background-color: rgba(240, 248, 255, 1) !important;
  }

  .note {
    background-color: #fbfae6 !important;
  }
  
  .white {
    color: white;
  }

  .mdTabs .md-tabs-container {
    transform: translate3d(0, 0, 0) !important;
  }

  .mdTabs .md-tabs .md-tab {
    display: none;

    &._isActive {
      display: block;
    }
  }

  .attachment-area__checkbox {
    margin-left: 10px;
  }

  .md-toolbar-row.case-avatar-row {
    min-height: 40px;

    .md-title {
      margin-top: 0;
      margin-bottom: 0;
    }
    .md-avatar {
      height: 30px;
      width: 30px;
      min-height: 30px;
      min-width: 30px;
      margin-right: 3px;
   }
  }

  .md-layout.case-view-wrapper {
    /* add this for mobile: margin-top: -12px; */
    margin-top: 0px;
  }

  /* @mention list height, scroll */
  .dropdown-menu {
    max-height: 315px;
    overflow-y: auto;
  }
  
  ._collapseFeed .md-collapse-content {
    position: relative;
    padding-top: 30px;
    
    ._filter {
      top: 0;
    }
  }
  
  ._collapseCaseFeed .md-collapse-content {
    padding: 0;
  }

  .md-table-cell:nth-child(3):last-child .md-table-cell-container,
  .md-table-head:nth-child(3):last-child{
    text-align: left !important;
    display: flex;
    justify-content: flex-start;
  }

  .md-collapse.md-success.is-active .md-collapse-label .md-collapse-title {
    color: black !important;
    font-size: 14px;
    font-weight: 500;
  }

  .md-collapse-label .md-collapse-title {
    color: black !important;
    font-size: 14px;
    font-weight: 500;
  }

  #app ._attachFileBtn,
  #app ._attachFileBtn:hover,
  #app ._attachFileBtn:active,
  #app ._attachFileBtn:focus,
  #app ._attachFileBtn:focus:active {
    background: transparent !important;
    border: none !important;
  }
</style>
